
const probdp1 = [

    {
        contestId: 1700,
        index: "F",
        name: "Puzzle",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2600,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1700,
        index: "D",
        name: "River Locks",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1900,
        tags: [
            "binary search",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1697,
        index: "E",
        name: "Coloring",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "brute force",
            "combinatorics",
            "constructive algorithms",
            "dp",
            "geometry",
            "graphs",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1695,
        index: "D2",
        name: "Tree Queries (Hard Version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2300,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1695,
        index: "D1",
        name: "Tree Queries (Easy Version)",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2200,
        tags: [
            "brute force",
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1695,
        index: "C",
        name: "Zero Path",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1700,
        tags: [
            "bitmasks",
            "brute force",
            "data structures",
            "dp",
            "graphs",
            "greedy",
            "shortest paths"
        ]
    },
    {
        contestId: 1693,
        index: "D",
        name: "Decinc Dividing",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2800,
        tags: [
            "brute force",
            "data structures",
            "divide and conquer",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1693,
        index: "B",
        name: "Fake Plastic Trees",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1692,
        index: "H",
        name: "Gambling",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1692,
        index: "G",
        name: "2^Sort",
        type: "PROGRAMMING",
        rating: 1400,
        tags: [
            "data structures",
            "dp",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1691,
        index: "F",
        name: "K-Set Tree",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2500,
        tags: [
            "combinatorics",
            "dfs and similar",
            "dp",
            "math",
            "trees"
        ]
    },
    {
        contestId: 1689,
        index: "D",
        name: "Lena and Matrix",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1900,
        tags: [
            "data structures",
            "dp",
            "geometry",
            "shortest paths"
        ]
    },
    {
        contestId: 1689,
        index: "C",
        name: "Infected Tree",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1600,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1686,
        index: "B",
        name: "Odd Subarrays",
        type: "PROGRAMMING",
        points: 1000,
        rating: 800,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1681,
        index: "F",
        name: "Unique Occurrences",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "data structures",
            "dfs and similar",
            "divide and conquer",
            "dp",
            "dsu",
            "trees"
        ]
    },
    {
        contestId: 1681,
        index: "E",
        name: "Labyrinth Adventures",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "data structures",
            "dp",
            "matrices",
            "shortest paths"
        ]
    },
    {
        contestId: 1681,
        index: "D",
        name: "Required Length",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "brute force",
            "dfs and similar",
            "dp",
            "hashing",
            "shortest paths"
        ]
    },
    {
        contestId: 1680,
        index: "E",
        name: "Moving Chips",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "bitmasks",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1679,
        index: "F",
        name: "Formalism for Formalism",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2600,
        tags: [
            "bitmasks",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1679,
        index: "E",
        name: "Typical Party in Dorm",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2400,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1679,
        index: "D",
        name: "Toss a Coin to Your Graph...",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1900,
        tags: [
            "binary search",
            "dfs and similar",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 1678,
        index: "B2",
        name: "Tokitsukaze and Good 01-String (hard version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1800,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1677,
        index: "F",
        name: "Tokitsukaze and Gems",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3500,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 1677,
        index: "D",
        name: "Tokitsukaze and Permutations",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 1677,
        index: "A",
        name: "Tokitsukaze and Strange Inequality",
        type: "PROGRAMMING",
        points: 500,
        rating: 1600,
        tags: [
            "brute force",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1676,
        index: "G",
        name: "White-Black Balanced Subtrees",
        type: "PROGRAMMING",
        rating: 1300,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1675,
        index: "G",
        name: "Sorting Pancakes",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1675,
        index: "F",
        name: "Vlad and Unfinished Business",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1674,
        index: "G",
        name: "Remove Directed Edges",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dfs and similar",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 1673,
        index: "C",
        name: "Palindrome Basis",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "brute force",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1671,
        index: "F",
        name: "Permutation Counting",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "brute force",
            "combinatorics",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 1671,
        index: "E",
        name: "Preorder",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "combinatorics",
            "divide and conquer",
            "dp",
            "dsu",
            "hashing",
            "sortings",
            "trees"
        ]
    },
    {
        contestId: 1670,
        index: "F",
        name: "Jee, You See?",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2400,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 1667,
        index: "E",
        name: "Centroid Probabilities",
        type: "PROGRAMMING",
        points: 2750,
        rating: 3000,
        tags: [
            "combinatorics",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 1667,
        index: "D",
        name: "Edge Elimination",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2900,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1667,
        index: "B",
        name: "Optimal Partition",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2100,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1666,
        index: "J",
        name: "Job Lookup",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "constructive algorithms",
            "dp",
            "shortest paths",
            "trees"
        ]
    },
    {
        contestId: 1666,
        index: "F",
        name: "Fancy Stack",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "combinatorics",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1663,
        index: "D",
        name: "Is it rated - 3",
        type: "PROGRAMMING",
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1662,
        index: "L",
        name: "Il Derby della Madonnina",
        type: "PROGRAMMING",
        tags: [
            "data structures",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1662,
        index: "G",
        name: "Gastronomic Event",
        type: "PROGRAMMING",
        tags: [
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1662,
        index: "C",
        name: "European Trip",
        type: "PROGRAMMING",
        tags: [
            "dp",
            "graphs",
            "math",
            "matrices"
        ]
    },
    {
        contestId: 1661,
        index: "E",
        name: "Narrow Components",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "dsu",
            "math",
            "trees"
        ]
    },
    {
        contestId: 1661,
        index: "B",
        name: "Getting Zero",
        type: "PROGRAMMING",
        rating: 1300,
        tags: [
            "bitmasks",
            "brute force",
            "dfs and similar",
            "dp",
            "graphs",
            "greedy",
            "shortest paths"
        ]
    },
    {
        contestId: 1660,
        index: "C",
        name: "Get an Even String",
        type: "PROGRAMMING",
        rating: 1300,
        tags: [
            "dp",
            "greedy",
            "strings"
        ]
    },
    {
        contestId: 1659,
        index: "C",
        name: "Line Empire",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "binary search",
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1658,
        index: "E",
        name: "Gojou and Matrix Game",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "data structures",
            "dp",
            "games",
            "hashing",
            "implementation",
            "math",
            "number theory",
            "sortings"
        ]
    },
    {
        contestId: 1657,
        index: "E",
        name: "Star MST",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "combinatorics",
            "dp",
            "graph matchings",
            "math"
        ]
    },
    {
        contestId: 1654,
        index: "H",
        name: "Three Minimums",
        type: "PROGRAMMING",
        points: 4000,
        rating: 3500,
        tags: [
            "combinatorics",
            "constructive algorithms",
            "divide and conquer",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 1650,
        index: "G",
        name: "Counting Shortcuts",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 1650,
        index: "F",
        name: "Vitaly and Advanced Useless Algorithms",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1648,
        index: "D",
        name: "Serious Business",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2800,
        tags: [
            "data structures",
            "divide and conquer",
            "dp",
            "implementation",
            "shortest paths"
        ]
    },
    {
        contestId: 1647,
        index: "F",
        name: "Madoka and Laziness",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3100,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1647,
        index: "D",
        name: "Madoka and the Best School in Russia",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "constructive algorithms",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1646,
        index: "E",
        name: "Power Board",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "brute force",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1646,
        index: "D",
        name: "Weight the Tree",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 1646,
        index: "C",
        name: "Factorials and Powers of Two",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1500,
        tags: [
            "bitmasks",
            "brute force",
            "constructive algorithms",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1644,
        index: "C",
        name: "Increase Subarray Sums",
        type: "PROGRAMMING",
        rating: 1400,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1637,
        index: "F",
        name: "Towers",
        type: "PROGRAMMING",
        points: 3250,
        rating: 2500,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1637,
        index: "D",
        name: "Yet Another Minimization Problem",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1637,
        index: "B",
        name: "MEX and Array",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1100,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1635,
        index: "D",
        name: "Infinite Set",
        type: "PROGRAMMING",
        points: 2250,
        rating: 1800,
        tags: [
            "bitmasks",
            "dp",
            "math",
            "matrices",
            "number theory",
            "strings"
        ]
    },
    {
        contestId: 1633,
        index: "D",
        name: "Make Them Equal",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1632,
        index: "C",
        name: "Strange Test",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1600,
        tags: [
            "binary search",
            "bitmasks",
            "brute force",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1631,
        index: "B",
        name: "Fun with Even Subarrays",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1100,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1630,
        index: "D",
        name: "Flipping Range",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy",
            "number theory"
        ]
    },
    {
        contestId: 1630,
        index: "C",
        name: "Paint the Middle",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2200,
        tags: [
            "dp",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1628,
        index: "D2",
        name: "Game on Sum (Hard Version)",
        type: "PROGRAMMING",
        points: 750,
        rating: 2400,
        tags: [
            "combinatorics",
            "dp",
            "games",
            "math"
        ]
    },
    {
        contestId: 1628,
        index: "D1",
        name: "Game on Sum (Easy Version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2100,
        tags: [
            "combinatorics",
            "dp",
            "games",
            "math"
        ]
    },
    {
        contestId: 1627,
        index: "E",
        name: "Not Escaping",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "data structures",
            "dp",
            "implementation",
            "shortest paths",
            "two pointers"
        ]
    },
    {
        contestId: 1627,
        index: "D",
        name: "Not Adding",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1900,
        tags: [
            "brute force",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1626,
        index: "F",
        name: "A Random Code Problem",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "number theory",
            "probabilities"
        ]
    },
    {
        contestId: 1626,
        index: "C",
        name: "Monsters And Spells",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "implementation",
            "math",
            "two pointers"
        ]
    },
    {
        contestId: 1625,
        index: "E1",
        name: "Cats on the Upgrade (easy version)",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "brute force",
            "data structures",
            "dfs and similar",
            "divide and conquer",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1625,
        index: "C",
        name: "Road Optimization",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1624,
        index: "E",
        name: "Masha-forgetful",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "brute force",
            "constructive algorithms",
            "dp",
            "hashing",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 1621,
        index: "G",
        name: "Weighted Increasing Subsequences",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3200,
        tags: [
            "data structures",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1621,
        index: "E",
        name: "New School",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 1620,
        index: "G",
        name: "Subsequences Galore",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 1620,
        index: "F",
        name: "Bipartite Array",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1620,
        index: "C",
        name: "BA-String",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1619,
        index: "E",
        name: "MEX and Increments",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "constructive algorithms",
            "data structures",
            "dp",
            "greedy",
            "implementation",
            "math",
            "sortings"
        ]
    },
    {
        contestId: 1618,
        index: "D",
        name: "Array and Operations",
        type: "PROGRAMMING",
        rating: 1300,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1617,
        index: "E",
        name: "Christmas Chocolates",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2700,
        tags: [
            "dfs and similar",
            "dp",
            "games",
            "graphs",
            "implementation",
            "math",
            "number theory",
            "shortest paths",
            "trees"
        ]
    },
    {
        contestId: 1616,
        index: "H",
        name: "Keep XOR Low",
        type: "PROGRAMMING",
        points: 4000,
        rating: 3000,
        tags: [
            "bitmasks",
            "combinatorics",
            "data structures",
            "divide and conquer",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1616,
        index: "G",
        name: "Just Add an Edge",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3500,
        tags: [
            "dfs and similar",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 1616,
        index: "D",
        name: "Keep the Average High",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1615,
        index: "F",
        name: "LEGOndary Grandmaster",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2800,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1614,
        index: "D2",
        name: "Divan and Kostomuksha (hard version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2300,
        tags: [
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 1614,
        index: "D1",
        name: "Divan and Kostomuksha (easy version)",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 1614,
        index: "C",
        name: "Divan and bitwise operations",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "bitmasks",
            "combinatorics",
            "constructive algorithms",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1613,
        index: "D",
        name: "MEX Sequences",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 1612,
        index: "F",
        name: "Armor and Weapons",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "shortest paths"
        ]
    },
    {
        contestId: 1612,
        index: "E",
        name: "Messages",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "probabilities",
            "sortings"
        ]
    },
    {
        contestId: 1611,
        index: "E2",
        name: "Escape The Maze (hard version)",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "shortest paths",
            "trees"
        ]
    },
    {
        contestId: 1610,
        index: "D",
        name: "Not Quite Lee",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2000,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1609,
        index: "E",
        name: "William The Oblivious ",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2400,
        tags: [
            "bitmasks",
            "data structures",
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 1609,
        index: "C",
        name: "Complex Market Analysis",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1400,
        tags: [
            "binary search",
            "dp",
            "implementation",
            "number theory",
            "schedules",
            "two pointers"
        ]
    },
    {
        contestId: 1608,
        index: "F",
        name: "MEX counting",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3200,
        tags: [
            "combinatorics",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1608,
        index: "C",
        name: "Game Master",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "graphs",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 1606,
        index: "F",
        name: "Tree Queries",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "brute force",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1606,
        index: "E",
        name: "Arena",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1605,
        index: "F",
        name: "PalindORme",
        type: "PROGRAMMING",
        points: 3500,
        rating: 2900,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 1603,
        index: "F",
        name: "October 18, 2017",
        type: "PROGRAMMING",
        points: 3750,
        rating: 2700,
        tags: [
            "combinatorics",
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1603,
        index: "E",
        name: "A Perfect Problem",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3200,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1603,
        index: "D",
        name: "Artistic Partition",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "divide and conquer",
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 1603,
        index: "C",
        name: "Extreme Extension",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2300,
        tags: [
            "dp",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1601,
        index: "E",
        name: "Phys Ed Online",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2900,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1601,
        index: "D",
        name: "Difficult Mountain",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2700,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1601,
        index: "C",
        name: "Optimal Insertion",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2300,
        tags: [
            "data structures",
            "divide and conquer",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1601,
        index: "B",
        name: "Frog Traveler",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1900,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "graphs",
            "shortest paths",
            "two pointers"
        ]
    },
    {
        contestId: 1598,
        index: "F",
        name: "RBS",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "binary search",
            "bitmasks",
            "brute force",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1598,
        index: "E",
        name: "Staircases",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "brute force",
            "combinatorics",
            "data structures",
            "dfs and similar",
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1598,
        index: "C",
        name: "Delete Two Elements",
        type: "PROGRAMMING",
        rating: 1200,
        tags: [
            "data structures",
            "dp",
            "implementation",
            "math",
            "two pointers"
        ]
    },
    {
        contestId: 1598,
        index: "A",
        name: "Computer Game",
        type: "PROGRAMMING",
        rating: 800,
        tags: [
            "brute force",
            "dfs and similar",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1594,
        index: "E2",
        name: "Rubik's Cube Coloring (hard version)",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2300,
        tags: [
            "brute force",
            "dp",
            "implementation",
            "math",
            "trees"
        ]
    },
    {
        contestId: 1594,
        index: "D",
        name: "The Number of Imposters",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1700,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "dsu",
            "graphs"
        ]
    },
    {
        contestId: 1593,
        index: "G",
        name: "Changing Brackets",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "constructive algorithms",
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1593,
        index: "F",
        name: "Red-Black Number",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "implementation",
            "math",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 1593,
        index: "B",
        name: "Make it Divisible by 25",
        type: "PROGRAMMING",
        rating: 900,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "math",
            "math"
        ]
    },
    {
        contestId: 1592,
        index: "C",
        name: "Bakry and Partitioning",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "bitmasks",
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1585,
        index: "G",
        name: "Poachers",
        type: "PROGRAMMING",
        points: 3500,
        rating: 2500,
        tags: [
            "dp",
            "games",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1585,
        index: "F",
        name: "Non-equal Neighbours",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2400,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1584,
        index: "F",
        name: "Strange LCS",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "bitmasks",
            "dp",
            "graphs",
            "greedy",
            "strings"
        ]
    },
    {
        contestId: 1583,
        index: "C",
        name: "Omkar and Determination",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1582,
        index: "F2",
        name: "Korney Korneevich and XOR (hard version)",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2400,
        tags: [
            "binary search",
            "brute force",
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 1582,
        index: "F1",
        name: "Korney Korneevich and XOR (easy version)",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "bitmasks",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1582,
        index: "E",
        name: "Pchelyonok and Segments",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2000,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1580,
        index: "D",
        name: "Subsequence",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2900,
        tags: [
            "brute force",
            "divide and conquer",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1580,
        index: "B",
        name: "Mathematics Curriculum",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2600,
        tags: [
            "brute force",
            "combinatorics",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1580,
        index: "A",
        name: "Portal",
        type: "PROGRAMMING",
        points: 500,
        rating: 1700,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1579,
        index: "G",
        name: "Minimal Coverage",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1575,
        index: "L",
        name: "Longest Array Deconstruction",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "data structures",
            "divide and conquer",
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 1575,
        index: "H",
        name: "Holiday Wall Ornaments",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1575,
        index: "D",
        name: "Divisible by Twenty-Five",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "brute force",
            "dfs and similar",
            "dp"
        ]
    },
    {
        contestId: 1574,
        index: "F",
        name: "Occurrences",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "combinatorics",
            "dfs and similar",
            "dp",
            "dsu",
            "fft",
            "graphs"
        ]
    },
    {
        contestId: 1572,
        index: "E",
        name: "Polygon",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "binary search",
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 1572,
        index: "C",
        name: "Paint",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2700,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1572,
        index: "A",
        name: "Book",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "binary search",
            "brute force",
            "data structures",
            "dp",
            "graphs",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 1571,
        index: "G",
        name: "A Battle Against a Dragon",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "*special",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1571,
        index: "F",
        name: "Kotlinforces",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "*special",
            "constructive algorithms",
            "dp"
        ]
    },
    {
        contestId: 1571,
        index: "E",
        name: "Fix the String",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "*special",
            "bitmasks",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1569,
        index: "F",
        name: "Palindromic Hamiltonian Path",
        type: "PROGRAMMING",
        rating: 3000,
        tags: [
            "brute force",
            "dfs and similar",
            "dp",
            "graphs",
            "hashing"
        ]
    },
    {
        contestId: 1567,
        index: "C",
        name: "Carrying Conundrum",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1600,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1566,
        index: "H",
        name: "Xor-quiz",
        type: "PROGRAMMING",
        points: 3750,
        rating: 3200,
        tags: [
            "constructive algorithms",
            "dp",
            "interactive",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1566,
        index: "F",
        name: "Points Movement",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 1566,
        index: "E",
        name: "Buds Re-hanging",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1566,
        index: "C",
        name: "MAX-MEX Cut",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1000,
        tags: [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1566,
        index: "B",
        name: "MIN-MEX Cut",
        type: "PROGRAMMING",
        points: 750,
        rating: 800,
        tags: [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1562,
        index: "E",
        name: "Rescue Niwen!",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2500,
        tags: [
            "dp",
            "greedy",
            "string suffix structures",
            "strings"
        ]
    },
    {
        contestId: 1562,
        index: "D1",
        name: "Two Hundred Twenty One (easy version)",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1700,
        tags: [
            "data structures",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1561,
        index: "D1",
        name: "Up the Strip (simplified version)",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1560,
        index: "F2",
        name: "Nearest Beautiful Number (hard version)",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "bitmasks",
            "brute force",
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1559,
        index: "E",
        name: "Mocha and Stars",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2200,
        tags: [
            "combinatorics",
            "dp",
            "fft",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1559,
        index: "B",
        name: "Mocha and Red and Blue",
        type: "PROGRAMMING",
        points: 750,
        rating: 900,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1558,
        index: "B",
        name: "Up the Strip",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1900,
        tags: [
            "brute force",
            "dp",
            "math",
            "number theory",
            "two pointers"
        ]
    },
    {
        contestId: 1557,
        index: "D",
        name: "Ezzat and Grid",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1557,
        index: "C",
        name: "Moamen and XOR",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1700,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "math",
            "matrices"
        ]
    },
    {
        contestId: 1556,
        index: "F",
        name: "Sports Betting",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "graphs",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1556,
        index: "E",
        name: "Equilibrium",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1555,
        index: "D",
        name: "Say No to Palindromes",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "brute force",
            "constructive algorithms",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1555,
        index: "C",
        name: "Coin Rows",
        type: "PROGRAMMING",
        rating: 1300,
        tags: [
            "brute force",
            "constructive algorithms",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1554,
        index: "E",
        name: "You",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2600,
        tags: [
            "dfs and similar",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1553,
        index: "I",
        name: "Stairs",
        type: "PROGRAMMING",
        points: 5250,
        rating: 3400,
        tags: [
            "combinatorics",
            "divide and conquer",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 1553,
        index: "D",
        name: "Backspace",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1500,
        tags: [
            "dp",
            "greedy",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 1553,
        index: "C",
        name: "Penalty",
        type: "PROGRAMMING",
        points: 750,
        rating: 1200,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1553,
        index: "B",
        name: "Reverse String",
        type: "PROGRAMMING",
        points: 500,
        rating: 1300,
        tags: [
            "brute force",
            "dp",
            "hashing",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 1552,
        index: "F",
        name: "Telepanting",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2200,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 1552,
        index: "D",
        name: "Array Differentiation",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1800,
        tags: [
            "bitmasks",
            "brute force",
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "graphs",
            "math"
        ]
    },
    {
        contestId: 1551,
        index: "F",
        name: "Equidistant Vertices",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "brute force",
            "combinatorics",
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1551,
        index: "E",
        name: "Fixed Points",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "binary search",
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 1550,
        index: "F",
        name: "Jumping Around",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "binary search",
            "data structures",
            "divide and conquer",
            "dp",
            "dsu",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 1550,
        index: "E",
        name: "Stringforces",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "binary search",
            "bitmasks",
            "brute force",
            "dp",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 1549,
        index: "B",
        name: "Gregor and the Pawn Game",
        type: "PROGRAMMING",
        points: 750,
        rating: 800,
        tags: [
            "dfs and similar",
            "dp",
            "flows",
            "graph matchings",
            "graphs",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1548,
        index: "C",
        name: "The Three Little Pigs",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2500,
        tags: [
            "combinatorics",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 1547,
        index: "G",
        name: "How Many Paths?",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1547,
        index: "E",
        name: "Air Conditioners",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "data structures",
            "dp",
            "implementation",
            "shortest paths",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1545,
        index: "F",
        name: "AquaMoon and Potatoes",
        type: "PROGRAMMING",
        points: 4000,
        rating: 3500,
        tags: [
            "brute force",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1545,
        index: "E2",
        name: "AquaMoon and Time Stop (hard version)",
        type: "PROGRAMMING",
        points: 2000,
        rating: 3500,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1545,
        index: "E1",
        name: "AquaMoon and Time Stop (easy version)",
        type: "PROGRAMMING",
        points: 2000,
        rating: 3500,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1542,
        index: "E2",
        name: "Abnormal Permutation Pairs (hard version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2700,
        tags: [
            "combinatorics",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 1542,
        index: "E1",
        name: "Abnormal Permutation Pairs (easy version)",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "combinatorics",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 1542,
        index: "D",
        name: "Priority Queue",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "combinatorics",
            "dp",
            "implementation",
            "math",
            "ternary search"
        ]
    },
    {
        contestId: 1540,
        index: "C2",
        name: "Converging Array (Hard Version)",
        type: "PROGRAMMING",
        points: 750,
        rating: 2900,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 1540,
        index: "C1",
        name: "Converging Array (Easy Version)",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2700,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 1540,
        index: "B",
        name: "Tree Array",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2300,
        tags: [
            "brute force",
            "combinatorics",
            "dp",
            "graphs",
            "math",
            "probabilities",
            "trees"
        ]
    },
    {
        contestId: 1539,
        index: "E",
        name: "Game with Cards",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "binary search",
            "constructive algorithms",
            "data structures",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1539,
        index: "B",
        name: "Love Song",
        type: "PROGRAMMING",
        points: 750,
        rating: 800,
        tags: [
            "dp",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 1538,
        index: "F",
        name: "Interesting Function",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "binary search",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1538,
        index: "A",
        name: "Stone Game",
        type: "PROGRAMMING",
        rating: 800,
        tags: [
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1537,
        index: "E1",
        name: "Erase and Extend (Easy Version)",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1600,
        tags: [
            "binary search",
            "brute force",
            "dp",
            "greedy",
            "hashing",
            "implementation",
            "string suffix structures",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 1536,
        index: "C",
        name: "Diluc and Kaeya",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "data structures",
            "dp",
            "hashing",
            "number theory"
        ]
    },
    {
        contestId: 1535,
        index: "E",
        name: "Gold Transfer",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "interactive",
            "trees"
        ]
    },
    {
        contestId: 1535,
        index: "D",
        name: "Playoff Tournament",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 1535,
        index: "C",
        name: "Unstable String",
        type: "PROGRAMMING",
        rating: 1400,
        tags: [
            "binary search",
            "dp",
            "greedy",
            "implementation",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 1534,
        index: "H",
        name: "Lost Nodes",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3500,
        tags: [
            "constructive algorithms",
            "dp",
            "graphs",
            "interactive",
            "sortings",
            "trees"
        ]
    },
    {
        contestId: 1534,
        index: "G",
        name: "A New Beginning",
        type: "PROGRAMMING",
        points: 3250,
        rating: 3300,
        tags: [
            "data structures",
            "dp",
            "geometry",
            "sortings"
        ]
    },
    {
        contestId: 1534,
        index: "F2",
        name: "Falling Sand (Hard Version)",
        type: "PROGRAMMING",
        points: 1250,
        rating: 3000,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "greedy"
        ]
    },
    {
        contestId: 1534,
        index: "C",
        name: "Little Alawn's Puzzle",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1300,
        tags: [
            "combinatorics",
            "dp",
            "dsu",
            "graphs",
            "math"
        ]
    },
    {
        contestId: 1533,
        index: "H",
        name: "Submatrices",
        type: "PROGRAMMING",
        tags: [
            "*special",
            "bitmasks",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1531,
        index: "C",
        name: "Симметричный амфитеатр",
        type: "PROGRAMMING",
        tags: [
            "*special",
            "constructive algorithms",
            "dp"
        ]
    },
    {
        contestId: 1530,
        index: "H",
        name: "Turing's Award",
        type: "PROGRAMMING",
        points: 4750,
        rating: 3400,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1530,
        index: "F",
        name: "Bingo",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2600,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1528,
        index: "E",
        name: "Mashtali and Hagh Trees",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2900,
        tags: [
            "combinatorics",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1528,
        index: "B",
        name: "Kavi on Pairing Duty",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1528,
        index: "A",
        name: "Parsa's Humongous Tree",
        type: "PROGRAMMING",
        points: 750,
        rating: 1600,
        tags: [
            "dfs and similar",
            "divide and conquer",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1527,
        index: "E",
        name: "Partition Game",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2500,
        tags: [
            "binary search",
            "data structures",
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 1526,
        index: "C1",
        name: "Potions (Easy Version)",
        type: "PROGRAMMING",
        points: 750,
        rating: 1500,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1526,
        index: "B",
        name: "I Hate 1111",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1525,
        index: "F",
        name: "Goblins And Gnomes",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "brute force",
            "dp",
            "flows",
            "graph matchings"
        ]
    },
    {
        contestId: 1525,
        index: "E",
        name: "Assimilation IV",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "probabilities",
            "two pointers"
        ]
    },
    {
        contestId: 1525,
        index: "D",
        name: "Armchairs",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp",
            "flows",
            "graph matchings",
            "greedy"
        ]
    },
    {
        contestId: 1523,
        index: "H",
        name: "Hopping Around the Array ",
        type: "PROGRAMMING",
        points: 3250,
        rating: 3500,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1523,
        index: "F",
        name: "Favorite Game",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3300,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 1523,
        index: "E",
        name: "Crypto Lights",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2600,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1523,
        index: "D",
        name: "Love-Hate",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2400,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 1521,
        index: "E",
        name: "Nastia and a Beautiful Matrix",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2700,
        tags: [
            "binary search",
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1521,
        index: "D",
        name: "Nastia Plays with a Tree",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2500,
        tags: [
            "constructive algorithms",
            "data structures",
            "dfs and similar",
            "dp",
            "dsu",
            "greedy",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 1519,
        index: "F",
        name: "Chests and Keys",
        type: "PROGRAMMING",
        rating: 3200,
        tags: [
            "bitmasks",
            "brute force",
            "dfs and similar",
            "dp",
            "flows"
        ]
    },
    {
        contestId: 1519,
        index: "D",
        name: "Maximum Sum of Products",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "brute force",
            "dp",
            "implementation",
            "math",
            "two pointers"
        ]
    },
    {
        contestId: 1519,
        index: "B",
        name: "The Cake Is a Lie",
        type: "PROGRAMMING",
        rating: 800,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 1517,
        index: "H",
        name: "Fly Around the World",
        type: "PROGRAMMING",
        points: 4000,
        rating: 3500,
        tags: [
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 1517,
        index: "F",
        name: "Reunion",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3200,
        tags: [
            "combinatorics",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1517,
        index: "D",
        name: "Explorer Space",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1800,
        tags: [
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 1516,
        index: "E",
        name: "Baby Ehab Plays with Permutations",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2500,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1516,
        index: "D",
        name: "Cut",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "graphs",
            "number theory",
            "two pointers"
        ]
    },
    {
        contestId: 1516,
        index: "C",
        name: "Baby Ehab Partitions Again",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1516,
        index: "B",
        name: "AGAGA XOOORRR",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1500,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1515,
        index: "E",
        name: "Phoenix and Computers",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2200,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1513,
        index: "C",
        name: "Add One",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1600,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 1512,
        index: "G",
        name: "Short Task",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "brute force",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1512,
        index: "F",
        name: "Education",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1511,
        index: "G",
        name: "Chips on a Board",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "bitmasks",
            "brute force",
            "data structures",
            "dp",
            "games",
            "two pointers"
        ]
    },
    {
        contestId: 1511,
        index: "F",
        name: "Chainword",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "matrices",
            "string suffix structures",
            "strings"
        ]
    },
    {
        contestId: 1511,
        index: "E",
        name: "Colorings and Dominoes",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "combinatorics",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1510,
        index: "H",
        name: "Hard Optimization",
        type: "PROGRAMMING",
        rating: 3200,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1510,
        index: "D",
        name: "Digits",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1509,
        index: "C",
        name: "The Sports Festival",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1800,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1506,
        index: "G",
        name: "Maximize the Remaining String",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "greedy",
            "strings"
        ]
    },
    {
        contestId: 1503,
        index: "E",
        name: "2-Coloring",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3100,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1503,
        index: "C",
        name: "Travelling Salesman Problem",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2200,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "shortest paths",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1501,
        index: "B",
        name: "Napoleon Cake",
        type: "PROGRAMMING",
        points: 1000,
        rating: 900,
        tags: [
            "dp",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 1500,
        index: "F",
        name: "Cupboards Jumps",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1499,
        index: "F",
        name: "Diameter Cuts",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "combinatorics",
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1499,
        index: "E",
        name: "Chaotic Merge",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "strings"
        ]
    },
    {
        contestId: 1499,
        index: "D",
        name: "The Number of Pairs",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1499,
        index: "B",
        name: "Binary Removals",
        type: "PROGRAMMING",
        rating: 1000,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1498,
        index: "F",
        name: "Christmas Game",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2500,
        tags: [
            "bitmasks",
            "data structures",
            "dfs and similar",
            "dp",
            "games",
            "math",
            "trees"
        ]
    },
    {
        contestId: 1498,
        index: "D",
        name: "Bananas in a Microwave",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "implementation"
        ]
    },
    {
        contestId: 1498,
        index: "C",
        name: "Planar Reflections",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1600,
        tags: [
            "brute force",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1497,
        index: "E2",
        name: "Square-free division (hard version)",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2500,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "math",
            "number theory",
            "two pointers"
        ]
    },
    {
        contestId: 1497,
        index: "E1",
        name: "Square-free division (easy version)",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "math",
            "number theory",
            "two pointers"
        ]
    },
    {
        contestId: 1497,
        index: "D",
        name: "Genius",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2500,
        tags: [
            "bitmasks",
            "dp",
            "graphs",
            "number theory"
        ]
    },
    {
        contestId: 1495,
        index: "F",
        name: "Squares",
        type: "PROGRAMMING",
        points: 3250,
        rating: 3300,
        tags: [
            "constructive algorithms",
            "data structures",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1494,
        index: "C",
        name: "1D Sokoban",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "binary search",
            "dp",
            "greedy",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 1492,
        index: "C",
        name: "Maximum width",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 1491,
        index: "D",
        name: "Zookeeper and The Infinite Zoo",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1800,
        tags: [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1491,
        index: "C",
        name: "Pekora and Trampoline",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1488,
        index: "E",
        name: "Palindromic Doubles",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "*special",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1487,
        index: "G",
        name: "String Counting",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "combinatorics",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 1487,
        index: "F",
        name: "Ones",
        type: "PROGRAMMING",
        rating: 2900,
        tags: [
            "dp",
            "greedy",
            "shortest paths"
        ]
    },
    {
        contestId: 1486,
        index: "F",
        name: "Pairs of Paths",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2600,
        tags: [
            "combinatorics",
            "data structures",
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1486,
        index: "E",
        name: "Paired Payment",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2200,
        tags: [
            "binary search",
            "brute force",
            "constructive algorithms",
            "dp",
            "flows",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 1486,
        index: "D",
        name: "Max Median",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2100,
        tags: [
            "binary search",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1485,
        index: "F",
        name: "Copy or Prefix Sum",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2400,
        tags: [
            "combinatorics",
            "data structures",
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 1485,
        index: "E",
        name: "Move and Swap",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1485,
        index: "B",
        name: "Replace and Keep Sorted",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1200,
        tags: [
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1482,
        index: "E",
        name: "Skyline Photo",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "data structures",
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 1481,
        index: "F",
        name: "AB Tree",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3100,
        tags: [
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1481,
        index: "E",
        name: "Sorting Books",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1479,
        index: "E",
        name: "School Clubs",
        type: "PROGRAMMING",
        points: 4000,
        rating: 3500,
        tags: [
            "dp",
            "fft",
            "math",
            "number theory",
            "probabilities"
        ]
    },
    {
        contestId: 1479,
        index: "B2",
        name: "Painting the Array II",
        type: "PROGRAMMING",
        points: 750,
        rating: 2100,
        tags: [
            "constructive algorithms",
            "data structures",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1479,
        index: "B1",
        name: "Painting the Array I",
        type: "PROGRAMMING",
        points: 750,
        rating: 1900,
        tags: [
            "constructive algorithms",
            "data structures",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1478,
        index: "B",
        name: "Nezzar and Lucky Number",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1100,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1476,
        index: "F",
        name: "Lanterns",
        type: "PROGRAMMING",
        rating: 3000,
        tags: [
            "binary search",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1476,
        index: "D",
        name: "Journey",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "dfs and similar",
            "dp",
            "dsu",
            "implementation"
        ]
    },
    {
        contestId: 1476,
        index: "C",
        name: "Longest Simple Cycle",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "dp",
            "graphs",
            "greedy"
        ]
    },
    {
        contestId: 1475,
        index: "G",
        name: "Strange Beauty",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "dp",
            "math",
            "number theory",
            "sortings"
        ]
    },
    {
        contestId: 1475,
        index: "D",
        name: "Cleaning the Phone",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "binary search",
            "dp",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1475,
        index: "B",
        name: "New Year's Number",
        type: "PROGRAMMING",
        rating: 900,
        tags: [
            "brute force",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1474,
        index: "F",
        name: "1 2 3 4 ...",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3000,
        tags: [
            "dp",
            "math",
            "matrices"
        ]
    },
    {
        contestId: 1474,
        index: "D",
        name: "Cleaning",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1473,
        index: "G",
        name: "Tiles",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "combinatorics",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 1473,
        index: "D",
        name: "Program",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "data structures",
            "dp",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 1472,
        index: "G",
        name: "Moving to the Capital",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 1472,
        index: "F",
        name: "New Year's Puzzle",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "brute force",
            "dp",
            "graph matchings",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1472,
        index: "E",
        name: "Correct Placement",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1472,
        index: "D",
        name: "Even-Odd Game",
        type: "PROGRAMMING",
        rating: 1200,
        tags: [
            "dp",
            "games",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1472,
        index: "C",
        name: "Long Jumps",
        type: "PROGRAMMING",
        rating: 1100,
        tags: [
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 1472,
        index: "B",
        name: "Fair Division",
        type: "PROGRAMMING",
        rating: 800,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1470,
        index: "E",
        name: "Strange Permutation",
        type: "PROGRAMMING",
        points: 2000,
        rating: 3200,
        tags: [
            "binary search",
            "combinatorics",
            "data structures",
            "dp",
            "graphs",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 1470,
        index: "A",
        name: "Strange Birthday Party",
        type: "PROGRAMMING",
        points: 500,
        rating: 1300,
        tags: [
            "binary search",
            "dp",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1469,
        index: "C",
        name: "Building a Fence",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "dp",
            "greedy",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 1469,
        index: "B",
        name: "Red and Blue",
        type: "PROGRAMMING",
        rating: 1000,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1468,
        index: "A",
        name: "LaIS",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1467,
        index: "E",
        name: "Distinctive Roots in a Tree",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1467,
        index: "D",
        name: "Sum of Paths",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2200,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1466,
        index: "H",
        name: "Finding satisfactory solutions",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3300,
        tags: [
            "combinatorics",
            "dp",
            "graphs",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1466,
        index: "C",
        name: "Canine poetry",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1300,
        tags: [
            "dp",
            "greedy",
            "strings"
        ]
    },
    {
        contestId: 1466,
        index: "B",
        name: "Last minute enhancements",
        type: "PROGRAMMING",
        points: 750,
        rating: 800,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1463,
        index: "F",
        name: "Max Correct Set",
        type: "PROGRAMMING",
        rating: 3100,
        tags: [
            "bitmasks",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1462,
        index: "B",
        name: "Last Year's Substring",
        type: "PROGRAMMING",
        rating: 800,
        tags: [
            "dp",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 1461,
        index: "F",
        name: "Mathematical Expression",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2700,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1461,
        index: "C",
        name: "Random Events",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1500,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1461,
        index: "B",
        name: "Find the Spruce",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1459,
        index: "B",
        name: "Move and Turn",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1300,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 1458,
        index: "B",
        name: "Glass Half Spilled",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1456,
        index: "E",
        name: "XOR-ranges",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3500,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1455,
        index: "G",
        name: "Forbidden Value",
        type: "PROGRAMMING",
        rating: 2900,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1455,
        index: "F",
        name: "String and Operations",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1455,
        index: "D",
        name: "Sequence and Swaps",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1453,
        index: "F",
        name: "Even Harder",
        type: "PROGRAMMING",
        points: 3500,
        rating: 2700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1453,
        index: "E",
        name: "Dog Snacks",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "binary search",
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1452,
        index: "E",
        name: "Two Editorials",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1452,
        index: "D",
        name: "Radio Towers",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1451,
        index: "C",
        name: "String Equality",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1400,
        tags: [
            "dp",
            "greedy",
            "hashing",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 1451,
        index: "B",
        name: "Non-Substring Subsequence",
        type: "PROGRAMMING",
        points: 750,
        rating: 900,
        tags: [
            "dp",
            "greedy",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 1450,
        index: "G",
        name: "Communism",
        type: "PROGRAMMING",
        points: 3750,
        rating: 3500,
        tags: [
            "bitmasks",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1446,
        index: "C",
        name: "Xor Tree",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2100,
        tags: [
            "binary search",
            "bitmasks",
            "data structures",
            "divide and conquer",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1446,
        index: "B",
        name: "Catching Cheaters",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1800,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1444,
        index: "E",
        name: "Finding the Vertex",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3500,
        tags: [
            "brute force",
            "dfs and similar",
            "dp",
            "interactive",
            "trees"
        ]
    },
    {
        contestId: 1444,
        index: "D",
        name: "Rectangular Polyline",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2900,
        tags: [
            "constructive algorithms",
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 1443,
        index: "B",
        name: "Saving the City",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1300,
        tags: [
            "dp",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        contestId: 1442,
        index: "E",
        name: "Black, White and Grey Tree",
        type: "PROGRAMMING",
        points: 1750,
        rating: 3000,
        tags: [
            "binary search",
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1442,
        index: "D",
        name: "Sum",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2800,
        tags: [
            "data structures",
            "divide and conquer",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1442,
        index: "A",
        name: "Extreme Subtraction",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1439,
        index: "D",
        name: "INOI Final Contests",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3100,
        tags: [
            "combinatorics",
            "dp",
            "fft"
        ]
    },
    {
        contestId: 1437,
        index: "F",
        name: "Emotional Fishermen",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "two pointers"
        ]
    },
    {
        contestId: 1437,
        index: "E",
        name: "Make It Increasing",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "binary search",
            "constructive algorithms",
            "data structures",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1437,
        index: "C",
        name: "Chef Monocarp",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp",
            "flows",
            "graph matchings",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        contestId: 1433,
        index: "F",
        name: "Zero Remainder Sum ",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1431,
        index: "J",
        name: "Zero-XOR Array",
        type: "PROGRAMMING",
        rating: 3400,
        tags: [
            "*special",
            "dp"
        ]
    },
    {
        contestId: 1431,
        index: "G",
        name: "Number Deletion Game",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "*special",
            "dp",
            "games",
            "greedy"
        ]
    },
    {
        contestId: 1430,
        index: "G",
        name: "Yet Another DAG Problem",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "bitmasks",
            "dfs and similar",
            "dp",
            "flows",
            "graphs",
            "math"
        ]
    },
    {
        contestId: 1430,
        index: "F",
        name: "Realistic Gameplay",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1428,
        index: "G2",
        name: "Lucky Numbers (Hard Version)",
        type: "PROGRAMMING",
        points: 750,
        rating: 3000,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1428,
        index: "G1",
        name: "Lucky Numbers (Easy Version)",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2900,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1428,
        index: "F",
        name: "Fruit Sequences",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2400,
        tags: [
            "binary search",
            "data structures",
            "divide and conquer",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 1427,
        index: "C",
        name: "The Hard Work of Paparazzi",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1426,
        index: "F",
        name: "Number of Subsequences",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "combinatorics",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1425,
        index: "D",
        name: "Danger of Mad Snakes",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1425,
        index: "B",
        name: "Blue and Red of Our Faculty!",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 1423,
        index: "J",
        name: "Bubble Cup hypothesis",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1422,
        index: "E",
        name: "Minlexes",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2700,
        tags: [
            "dp",
            "greedy",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 1422,
        index: "C",
        name: "Bargain",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1421,
        index: "E",
        name: "Swedish Heroes",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1420,
        index: "E",
        name: "Battle Lemmings",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2500,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1420,
        index: "C2",
        name: "Pokémon Army (hard version)",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2100,
        tags: [
            "data structures",
            "divide and conquer",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1420,
        index: "C1",
        name: "Pokémon Army (easy version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1300,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1418,
        index: "C",
        name: "Mortal Kombat Tower",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "dp",
            "graphs",
            "greedy",
            "shortest paths"
        ]
    },
    {
        contestId: 1416,
        index: "E",
        name: "Split",
        type: "PROGRAMMING",
        points: 2250,
        rating: 3200,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1416,
        index: "C",
        name: "XOR Inverse",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2000,
        tags: [
            "bitmasks",
            "data structures",
            "divide and conquer",
            "dp",
            "greedy",
            "math",
            "sortings",
            "strings",
            "trees"
        ]
    },
    {
        contestId: 1415,
        index: "F",
        name: "Cakes for Clones",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1415,
        index: "C",
        name: "Bouncing Ball",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1400,
        tags: [
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1413,
        index: "C",
        name: "Perform Easily",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "binary search",
            "brute force",
            "dp",
            "implementation",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1409,
        index: "F",
        name: "Subsequences of Length Two",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1409,
        index: "E",
        name: "Two Platforms",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "binary search",
            "dp",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1408,
        index: "I",
        name: "Bitwise Magic",
        type: "PROGRAMMING",
        points: 3750,
        rating: 3200,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 1408,
        index: "G",
        name: "Clusterization Counting",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2700,
        tags: [
            "combinatorics",
            "dp",
            "dsu",
            "fft",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1408,
        index: "D",
        name: "Searchlights",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "binary search",
            "brute force",
            "data structures",
            "dp",
            "implementation",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1408,
        index: "C",
        name: "Discrete Acceleration",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1500,
        tags: [
            "binary search",
            "dp",
            "implementation",
            "math",
            "two pointers"
        ]
    },
    {
        contestId: 1407,
        index: "E",
        name: "Egor in the Republic of Dagestan",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "graphs",
            "greedy",
            "shortest paths"
        ]
    },
    {
        contestId: 1407,
        index: "D",
        name: "Discrete Centrifugal Jumps",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "data structures",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 1406,
        index: "B",
        name: "Maximum Product",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1200,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 1404,
        index: "B",
        name: "Tree Tag",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "dfs and similar",
            "dp",
            "games",
            "trees"
        ]
    },
    {
        contestId: 1403,
        index: "C",
        name: "Chess Rush",
        type: "PROGRAMMING",
        rating: 3200,
        tags: [
            "*special",
            "combinatorics",
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1402,
        index: "C",
        name: "Star Trek",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "*special",
            "combinatorics",
            "dfs and similar",
            "dp",
            "games",
            "graphs",
            "matrices",
            "trees"
        ]
    },
    {
        contestId: 1401,
        index: "D",
        name: "Maximum Distributed Tree",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1800,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "implementation",
            "math",
            "number theory",
            "sortings",
            "trees"
        ]
    },
    {
        contestId: 1400,
        index: "G",
        name: "Mercenaries",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "bitmasks",
            "brute force",
            "combinatorics",
            "dp",
            "dsu",
            "math",
            "two pointers"
        ]
    },
    {
        contestId: 1400,
        index: "F",
        name: "x-prime Substrings",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "brute force",
            "dfs and similar",
            "dp",
            "string suffix structures",
            "strings"
        ]
    },
    {
        contestId: 1400,
        index: "E",
        name: "Clear the Multiset",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "data structures",
            "divide and conquer",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1399,
        index: "F",
        name: "Yet Another Segments Subset",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "data structures",
            "dp",
            "graphs",
            "sortings"
        ]
    },
    {
        contestId: 1398,
        index: "F",
        name: "Controversial Rounds",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 1398,
        index: "D",
        name: "Colored Rectangles",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1398,
        index: "C",
        name: "Good Subarrays",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "data structures",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1396,
        index: "C",
        name: "Monster Invaders",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2300,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1395,
        index: "C",
        name: "Boboniu and Bit Operations",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1600,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1394,
        index: "D",
        name: "Boboniu and Jianghu",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2800,
        tags: [
            "dp",
            "greedy",
            "sortings",
            "trees"
        ]
    },
    {
        contestId: 1394,
        index: "A",
        name: "Boboniu Chats with Du",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "dp",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1393,
        index: "E2",
        name: "Twilight and Ancient Scroll (harder version)",
        type: "PROGRAMMING",
        points: 1500,
        rating: 3200,
        tags: [
            "dp",
            "hashing",
            "implementation",
            "string suffix structures",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 1393,
        index: "E1",
        name: "Twilight and Ancient Scroll (easier version)",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2800,
        tags: [
            "dp",
            "hashing",
            "implementation",
            "string suffix structures",
            "strings"
        ]
    },
    {
        contestId: 1393,
        index: "D",
        name: "Rarity and New Dress",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "implementation",
            "shortest paths"
        ]
    },
    {
        contestId: 1392,
        index: "H",
        name: "ZS Shuffles Cards",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3000,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1392,
        index: "G",
        name: "Omkar and Pies",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2900,
        tags: [
            "bitmasks",
            "dfs and similar",
            "dp",
            "math",
            "shortest paths"
        ]
    },
    {
        contestId: 1392,
        index: "D",
        name: "Omkar and Bed Wars",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1391,
        index: "D",
        name: "505",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "bitmasks",
            "brute force",
            "constructive algorithms",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1391,
        index: "C",
        name: "Cyclic Permutations ",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1500,
        tags: [
            "combinatorics",
            "dp",
            "graphs",
            "math"
        ]
    },
    {
        contestId: 1389,
        index: "G",
        name: "Directing Edges",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1389,
        index: "F",
        name: "Bicolored Segments",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "data structures",
            "dp",
            "graph matchings",
            "sortings"
        ]
    },
    {
        contestId: 1389,
        index: "C",
        name: "Good String",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 1389,
        index: "B",
        name: "Array Walk",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1387,
        index: "C",
        name: "Viruses",
        type: "PROGRAMMING",
        rating: 2900,
        tags: [
            "*special",
            "dp",
            "shortest paths",
            "string suffix structures"
        ]
    },
    {
        contestId: 1387,
        index: "B1",
        name: "Village (Minimum)",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "*special",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1387,
        index: "A",
        name: "Graph",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "*special",
            "binary search",
            "dfs and similar",
            "dp",
            "math",
            "ternary search"
        ]
    },
    {
        contestId: 1385,
        index: "D",
        name: "a-Good String",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "bitmasks",
            "brute force",
            "divide and conquer",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1384,
        index: "B2",
        name: "Koa and the Beach (Hard Version)",
        type: "PROGRAMMING",
        points: 750,
        rating: 2200,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1384,
        index: "B1",
        name: "Koa and the Beach (Easy Version)",
        type: "PROGRAMMING",
        points: 500,
        rating: 1900,
        tags: [
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1383,
        index: "E",
        name: "Strange Operation",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2800,
        tags: [
            "combinatorics",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1383,
        index: "C",
        name: "String Transformation 2",
        type: "PROGRAMMING",
        points: 1750,
        rating: 3100,
        tags: [
            "bitmasks",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1383,
        index: "B",
        name: "GameGame",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "games",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1382,
        index: "B",
        name: "Sequential Nim",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1100,
        tags: [
            "dp",
            "games"
        ]
    },
    {
        contestId: 1381,
        index: "D",
        name: "The Majestic Brown Tree Snake",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "trees",
            "two pointers"
        ]
    },
    {
        contestId: 1381,
        index: "B",
        name: "Unmerge",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1380,
        index: "F",
        name: "Strange Addition",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "data structures",
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 1380,
        index: "C",
        name: "Create The Teams",
        type: "PROGRAMMING",
        rating: 1400,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 1379,
        index: "E",
        name: "Inverse Genealogy",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2800,
        tags: [
            "constructive algorithms",
            "divide and conquer",
            "dp",
            "math",
            "trees"
        ]
    },
    {
        contestId: 1379,
        index: "C",
        name: "Choosing flowers",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2000,
        tags: [
            "binary search",
            "brute force",
            "data structures",
            "dfs and similar",
            "dp",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1373,
        index: "E",
        name: "Sum of Digits",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "brute force",
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1373,
        index: "D",
        name: "Maximum Sum on Even Positions",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "divide and conquer",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1372,
        index: "E",
        name: "Omkar and Last Floor",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2900,
        tags: [
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 1372,
        index: "D",
        name: "Omkar and Circle",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "brute force",
            "dp",
            "games",
            "greedy"
        ]
    },
    {
        contestId: 1371,
        index: "E2",
        name: "Asterism (Hard Version)",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2300,
        tags: [
            "binary search",
            "combinatorics",
            "dp",
            "math",
            "number theory",
            "sortings"
        ]
    },
    {
        contestId: 1370,
        index: "D",
        name: "Odd-Even Subsequence",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "binary search",
            "dp",
            "dsu",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1369,
        index: "F",
        name: "BareLee",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2700,
        tags: [
            "dfs and similar",
            "dp",
            "games"
        ]
    },
    {
        contestId: 1369,
        index: "D",
        name: "TediousLee",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dp",
            "graphs",
            "greedy",
            "math",
            "trees"
        ]
    },
    {
        contestId: 1368,
        index: "H1",
        name: "Breadboard Capacity (easy version)",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3300,
        tags: [
            "dp",
            "flows",
            "greedy"
        ]
    },
    {
        contestId: 1367,
        index: "F2",
        name: "Flying Sort (Hard Version)",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1367,
        index: "F1",
        name: "Flying Sort (Easy Version)",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 1367,
        index: "E",
        name: "Necklace Assembly",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "brute force",
            "dfs and similar",
            "dp",
            "graphs",
            "greedy",
            "number theory"
        ]
    },
    {
        contestId: 1366,
        index: "G",
        name: "Construct the String",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "data structures",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1366,
        index: "F",
        name: "Jog Around The Graph",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "binary search",
            "dp",
            "geometry",
            "graphs"
        ]
    },
    {
        contestId: 1366,
        index: "E",
        name: "Two Arrays",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "binary search",
            "brute force",
            "combinatorics",
            "constructive algorithms",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 1363,
        index: "F",
        name: "Rotating Substrings",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2600,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1363,
        index: "E",
        name: "Tree Shuffling",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2000,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1360,
        index: "F",
        name: "Spy-string",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "bitmasks",
            "brute force",
            "constructive algorithms",
            "dp",
            "hashing",
            "strings"
        ]
    },
    {
        contestId: 1360,
        index: "E",
        name: "Polygon",
        type: "PROGRAMMING",
        rating: 1300,
        tags: [
            "dp",
            "graphs",
            "implementation",
            "shortest paths"
        ]
    },
    {
        contestId: 1359,
        index: "D",
        name: "Yet Another Yet Another Task",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "data structures",
            "dp",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 1359,
        index: "B",
        name: "New Theatre Square",
        type: "PROGRAMMING",
        rating: 1000,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 1355,
        index: "B",
        name: "Young Explorers",
        type: "PROGRAMMING",
        points: 750,
        rating: 1200,
        tags: [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1354,
        index: "F",
        name: "Summoning Minions",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "constructive algorithms",
            "dp",
            "flows",
            "graph matchings",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1354,
        index: "E",
        name: "Graph Coloring",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 1354,
        index: "B",
        name: "Ternary String",
        type: "PROGRAMMING",
        rating: 1200,
        tags: [
            "binary search",
            "dp",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 1353,
        index: "F",
        name: "Decreasing Heights",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 1353,
        index: "E",
        name: "K-periodic Garland",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1350,
        index: "B",
        name: "Orac and Models",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1349,
        index: "F2",
        name: "Slime and Sequences (Hard Version)",
        type: "PROGRAMMING",
        points: 1750,
        rating: 3500,
        tags: [
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 1349,
        index: "F1",
        name: "Slime and Sequences (Easy Version)",
        type: "PROGRAMMING",
        points: 1750,
        rating: 3100,
        tags: [
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 1349,
        index: "E",
        name: "Slime and Hats",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3500,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1348,
        index: "E",
        name: "Phoenix and Berries",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1346,
        index: "I",
        name: "Pac-Man 2.0",
        type: "PROGRAMMING",
        rating: 2900,
        tags: [
            "*special",
            "dp"
        ]
    },
    {
        contestId: 1346,
        index: "E",
        name: "Magic Tricks",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "*special",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 1345,
        index: "B",
        name: "Card Constructions",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1100,
        tags: [
            "binary search",
            "brute force",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1344,
        index: "C",
        name: "Quantifier Question",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2600,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "math"
        ]
    },
    {
        contestId: 1343,
        index: "C",
        name: "Alternating Subsequence",
        type: "PROGRAMMING",
        rating: 1200,
        tags: [
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 1342,
        index: "F",
        name: "Make It Ascending",
        type: "PROGRAMMING",
        rating: 3000,
        tags: [
            "bitmasks",
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 1340,
        index: "C",
        name: "Nastya and Unexpected Guest",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2400,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 1340,
        index: "B",
        name: "Nastya and Scoreboard",
        type: "PROGRAMMING",
        points: 750,
        rating: 1700,
        tags: [
            "bitmasks",
            "dp",
            "graphs",
            "greedy"
        ]
    },
    {
        contestId: 1339,
        index: "A",
        name: "Filling Diamonds",
        type: "PROGRAMMING",
        points: 500,
        rating: 900,
        tags: [
            "brute force",
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1338,
        index: "D",
        name: "Nested Rubber Bands",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2700,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "math",
            "trees"
        ]
    },
    {
        contestId: 1336,
        index: "C",
        name: "Kaavi and Magic Spell",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2200,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1336,
        index: "A",
        name: "Linova and Kingdom",
        type: "PROGRAMMING",
        points: 500,
        rating: 1600,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "sortings",
            "trees"
        ]
    },
    {
        contestId: 1335,
        index: "E2",
        name: "Three Blocks Palindrome (hard version)",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 1335,
        index: "E1",
        name: "Three Blocks Palindrome (easy version)",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "binary search",
            "brute force",
            "data structures",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 1334,
        index: "F",
        name: "Strange Function",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1332,
        index: "F",
        name: "Independent Set",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2500,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1331,
        index: "F",
        name: "Elementary!",
        type: "PROGRAMMING",
        tags: [
            "*special",
            "brute force",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1328,
        index: "D",
        name: "Carousel",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "constructive algorithms",
            "dp",
            "graphs",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1327,
        index: "G",
        name: "Letters and Question Marks",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "bitmasks",
            "dp",
            "string suffix structures"
        ]
    },
    {
        contestId: 1327,
        index: "F",
        name: "AND Segments",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "bitmasks",
            "combinatorics",
            "data structures",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 1327,
        index: "E",
        name: "Count The Blocks",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1326,
        index: "G",
        name: "Spiderweb Trees",
        type: "PROGRAMMING",
        points: 4000,
        rating: 3500,
        tags: [
            "dp",
            "geometry",
            "trees"
        ]
    },
    {
        contestId: 1326,
        index: "F2",
        name: "Wise Men (Hard Version)",
        type: "PROGRAMMING",
        points: 1500,
        rating: 3200,
        tags: [
            "bitmasks",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1326,
        index: "F1",
        name: "Wise Men (Easy Version)",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 1324,
        index: "F",
        name: "Maximum White Subtree",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1324,
        index: "E",
        name: "Sleeping Schedule",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1323,
        index: "A",
        name: "Even Subset Sum Problem",
        type: "PROGRAMMING",
        points: 500,
        rating: 800,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1322,
        index: "F",
        name: "Assigning Fares",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3500,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1322,
        index: "D",
        name: "Reality Show",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2800,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 1320,
        index: "E",
        name: "Treeland and Viruses",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "shortest paths",
            "trees"
        ]
    },
    {
        contestId: 1320,
        index: "A",
        name: "Journey Planning",
        type: "PROGRAMMING",
        points: 500,
        rating: 1400,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        contestId: 1316,
        index: "E",
        name: "Team Building",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "bitmasks",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1315,
        index: "B",
        name: "Homecoming",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1300,
        tags: [
            "binary search",
            "dp",
            "greedy",
            "strings"
        ]
    },
    {
        contestId: 1313,
        index: "D",
        name: "Happy New Year",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "bitmasks",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1313,
        index: "C2",
        name: "Skyscrapers (hard version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1313,
        index: "C1",
        name: "Skyscrapers (easy version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1500,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1312,
        index: "G",
        name: "Autocompletion",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "data structures",
            "dfs and similar",
            "dp"
        ]
    },
    {
        contestId: 1312,
        index: "E",
        name: "Array Shrinking",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1310,
        index: "E",
        name: "Strange Function",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1310,
        index: "D",
        name: "Tourism",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "dp",
            "graphs",
            "probabilities"
        ]
    },
    {
        contestId: 1310,
        index: "C",
        name: "Au Pont Rouge",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2800,
        tags: [
            "binary search",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1310,
        index: "B",
        name: "Double Elimination",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2500,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1307,
        index: "E",
        name: "Cow and Treats",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "binary search",
            "combinatorics",
            "dp",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1307,
        index: "C",
        name: "Cow and Message",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "brute force",
            "dp",
            "math",
            "strings"
        ]
    },
    {
        contestId: 1305,
        index: "G",
        name: "Kuroni and Antihype",
        type: "PROGRAMMING",
        points: 3250,
        rating: 3500,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "dsu",
            "graphs"
        ]
    },
    {
        contestId: 1304,
        index: "F2",
        name: "Animal Observation (hard version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2400,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1304,
        index: "F1",
        name: "Animal Observation (easy version)",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2300,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1304,
        index: "C",
        name: "Air Conditioner",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "dp",
            "greedy",
            "implementation",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1303,
        index: "E",
        name: "Erase Subsequences",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1301,
        index: "E",
        name: "Nanosoft",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1299,
        index: "D",
        name: "Around the World",
        type: "PROGRAMMING",
        points: 1750,
        rating: 3000,
        tags: [
            "bitmasks",
            "combinatorics",
            "dfs and similar",
            "dp",
            "graphs",
            "graphs",
            "math",
            "trees"
        ]
    },
    {
        contestId: 1297,
        index: "H",
        name: "Paint the String",
        type: "PROGRAMMING",
        tags: [
            "*special",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1297,
        index: "G",
        name: "M-numbers",
        type: "PROGRAMMING",
        tags: [
            "*special",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1296,
        index: "E2",
        name: "String Coloring (hard version)",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1296,
        index: "E1",
        name: "String Coloring (easy version)",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "constructive algorithms",
            "dp",
            "graphs",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1295,
        index: "F",
        name: "Good Contest",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "combinatorics",
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 1295,
        index: "C",
        name: "Obtain The String",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "dp",
            "greedy",
            "strings"
        ]
    },
    {
        contestId: 1294,
        index: "F",
        name: "Three Paths on a Tree",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1292,
        index: "F",
        name: "Nora's Toy Boxes",
        type: "PROGRAMMING",
        points: 2750,
        rating: 3500,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 1292,
        index: "D",
        name: "Chaotic V.",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2700,
        tags: [
            "dp",
            "graphs",
            "greedy",
            "math",
            "number theory",
            "trees"
        ]
    },
    {
        contestId: 1292,
        index: "C",
        name: "Xenon's Attack on the Gangs",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2300,
        tags: [
            "combinatorics",
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1290,
        index: "F",
        name: "Making Shapes",
        type: "PROGRAMMING",
        points: 3250,
        rating: 3500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1288,
        index: "D",
        name: "Minimax Problem",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "binary search",
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 1288,
        index: "C",
        name: "Two Arrays",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 1286,
        index: "F",
        name: "Harry The Potter",
        type: "PROGRAMMING",
        points: 2750,
        rating: 3100,
        tags: [
            "brute force",
            "constructive algorithms",
            "dp",
            "fft",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1286,
        index: "A",
        name: "Garland",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1285,
        index: "E",
        name: "Delete a Segment",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "brute force",
            "constructive algorithms",
            "data structures",
            "dp",
            "graphs",
            "sortings",
            "trees",
            "two pointers"
        ]
    },
    {
        contestId: 1285,
        index: "D",
        name: "Dr. Evil Underscores",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1900,
        tags: [
            "bitmasks",
            "brute force",
            "dfs and similar",
            "divide and conquer",
            "dp",
            "greedy",
            "strings",
            "trees"
        ]
    },
    {
        contestId: 1285,
        index: "B",
        name: "Just Eat It!",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1300,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1284,
        index: "B",
        name: "New Year and Ascent Sequence",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1400,
        tags: [
            "binary search",
            "combinatorics",
            "data structures",
            "dp",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 1283,
        index: "E",
        name: "New Year Parties",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1282,
        index: "B2",
        name: "K for the Price of One (Hard Version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1600,
        tags: [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1282,
        index: "B1",
        name: "K for the Price of One (Easy Version)",
        type: "PROGRAMMING",
        points: 500,
        rating: 1400,
        tags: [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1280,
        index: "D",
        name: "Miss Punyverse",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2500,
        tags: [
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1279,
        index: "F",
        name: "New Year and Handle Change",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 1279,
        index: "E",
        name: "New Year Permutations",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 1278,
        index: "F",
        name: "Cards",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "number theory",
            "probabilities"
        ]
    },
    {
        contestId: 1278,
        index: "C",
        name: "Berry Jam",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1276,
        index: "D",
        name: "Tree Elimination",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2900,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1276,
        index: "A",
        name: "As Simple as One and Two",
        type: "PROGRAMMING",
        points: 500,
        rating: 1400,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1272,
        index: "F",
        name: "Two Bracket Sequences",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dp",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 1272,
        index: "D",
        name: "Remove One Element",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 1272,
        index: "C",
        name: "Yet Another Broken Keyboard",
        type: "PROGRAMMING",
        rating: 1200,
        tags: [
            "combinatorics",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1271,
        index: "E",
        name: "Common Number",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2100,
        tags: [
            "binary search",
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1271,
        index: "D",
        name: "Portals",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2100,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 1268,
        index: "E",
        name: "Happy Cactus",
        type: "PROGRAMMING",
        points: 2750,
        rating: 3400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1268,
        index: "B",
        name: "Domino for Young",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2000,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1266,
        index: "H",
        name: "Red-Blue Graph",
        type: "PROGRAMMING",
        points: 4000,
        rating: 3400,
        tags: [
            "dp",
            "graphs",
            "math",
            "matrices",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 1265,
        index: "E",
        name: "Beautiful Mirrors",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "data structures",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1264,
        index: "D1",
        name: "Beautiful Bracket Sequence (easy version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2600,
        tags: [
            "combinatorics",
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 1263,
        index: "F",
        name: "Economic Difficulties",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2400,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "flows",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1260,
        index: "E",
        name: "Tournament",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1260,
        index: "D",
        name: "A Game with Traps",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "binary search",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1257,
        index: "E",
        name: "The Contest",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1257,
        index: "D",
        name: "Yet Another Monster Killing Problem",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1256,
        index: "E",
        name: "Yet Another Division Into Teams",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1253,
        index: "E",
        name: "Antenna Coverage",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2200,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1253,
        index: "C",
        name: "Sweets Eating",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "dp",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        contestId: 1252,
        index: "J",
        name: "Tiling Terrace",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 1252,
        index: "D",
        name: "Find String in a Grid",
        type: "PROGRAMMING",
        rating: 3000,
        tags: [
            "data structures",
            "dp",
            "strings",
            "trees"
        ]
    },
    {
        contestId: 1252,
        index: "B",
        name: "Cleaning Robots",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1251,
        index: "E1",
        name: "Voting (Easy Version)",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1250,
        index: "G",
        name: "Discarding Game",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 1250,
        index: "D",
        name: "Conference Problem",
        type: "PROGRAMMING",
        rating: 3000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1249,
        index: "F",
        name: "Maximum Weight Subset",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1249,
        index: "E",
        name: "By Elevator or Stairs?",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "dp",
            "shortest paths"
        ]
    },
    {
        contestId: 1248,
        index: "D1",
        name: "The World Is Just a Programming Task (Easy Version)",
        type: "PROGRAMMING",
        points: 750,
        rating: 2000,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1245,
        index: "F",
        name: "Daniel and Spring Cleaning",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "bitmasks",
            "brute force",
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 1245,
        index: "E",
        name: "Hyakugoku and Ladders",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "dp",
            "probabilities",
            "shortest paths"
        ]
    },
    {
        contestId: 1245,
        index: "C",
        name: "Constanze's Machine",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1245,
        index: "B",
        name: "Restricted RPS",
        type: "PROGRAMMING",
        points: 750,
        rating: 1200,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1244,
        index: "D",
        name: "Paint the Tree",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1800,
        tags: [
            "brute force",
            "constructive algorithms",
            "dp",
            "graphs",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 1242,
        index: "C",
        name: "Sum Balance",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2400,
        tags: [
            "bitmasks",
            "dfs and similar",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 1239,
        index: "E",
        name: "Turtle",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3100,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1239,
        index: "A",
        name: "Ivan the Fool and the Probability Theory",
        type: "PROGRAMMING",
        points: 500,
        rating: 1700,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1238,
        index: "F",
        name: "The Maximum Subtree",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1238,
        index: "E",
        name: "Keyboard Purchase",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 1238,
        index: "D",
        name: "AB-string",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "binary search",
            "combinatorics",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1238,
        index: "C",
        name: "Standard Free2play",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1237,
        index: "G",
        name: "Balanced Distribution",
        type: "PROGRAMMING",
        points: 3750,
        rating: 3500,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1237,
        index: "F",
        name: "Balanced Domino Placements",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2600,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 1237,
        index: "E",
        name: "Balanced Binary Search Trees",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 1236,
        index: "E",
        name: "Alice and the Unfair Game",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "dsu"
        ]
    },
    {
        contestId: 1234,
        index: "F",
        name: "Yet Another Substring Reverse",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 1234,
        index: "C",
        name: "Pipes",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1228,
        index: "E",
        name: "Another Filling the Grid",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1227,
        index: "F1",
        name: "Wrong Answer on test 233 (Easy Version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2200,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1225,
        index: "G",
        name: "To Make 1",
        type: "PROGRAMMING",
        points: 3750,
        rating: 3100,
        tags: [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "greedy",
            "number theory"
        ]
    },
    {
        contestId: 1225,
        index: "E",
        name: "Rock Is Push",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2200,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 1223,
        index: "F",
        name: "Stack Exterminable Arrays",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2600,
        tags: [
            "data structures",
            "divide and conquer",
            "dp",
            "hashing"
        ]
    },
    {
        contestId: 1223,
        index: "E",
        name: "Paint the Tree",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2100,
        tags: [
            "dp",
            "sortings",
            "trees"
        ]
    },
    {
        contestId: 1223,
        index: "D",
        name: "Sequence Sorting",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 1221,
        index: "G",
        name: "Graph And Numbers",
        type: "PROGRAMMING",
        rating: 2900,
        tags: [
            "bitmasks",
            "brute force",
            "combinatorics",
            "dp",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 1221,
        index: "D",
        name: "Make The Fence Great Again",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1220,
        index: "E",
        name: "Tourism",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2200,
        tags: [
            "dfs and similar",
            "dp",
            "dsu",
            "graphs",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1218,
        index: "C",
        name: "Jumping Transformers",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1218,
        index: "A",
        name: "BubbleReactor",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 1216,
        index: "F",
        name: "Wi-Fi",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1215,
        index: "E",
        name: "Marbles",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 1215,
        index: "B",
        name: "The Number of Products",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "combinatorics",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1214,
        index: "D",
        name: "Treasure Island",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dfs and similar",
            "dp",
            "flows",
            "hashing"
        ]
    },
    {
        contestId: 1211,
        index: "H",
        name: "Road Repair in Treeland",
        type: "PROGRAMMING",
        rating: 3100,
        tags: [
            "*special",
            "binary search",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1210,
        index: "G",
        name: "Mateusz and Escape Room",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1209,
        index: "E2",
        name: "Rotate Columns (hard version)",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2500,
        tags: [
            "bitmasks",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1209,
        index: "E1",
        name: "Rotate Columns (easy version)",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2000,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1208,
        index: "F",
        name: "Bits And Pieces",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "bitmasks",
            "dfs and similar",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1207,
        index: "C",
        name: "Gas Pipeline",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1206,
        index: "B",
        name: "Make Product Equal One",
        type: "PROGRAMMING",
        points: 1000,
        rating: 900,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1204,
        index: "E",
        name: "Natasha, Sasha and the Prefix Sums",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1204,
        index: "C",
        name: "Anna, Svyatoslav and Maps",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1700,
        tags: [
            "dp",
            "graphs",
            "greedy",
            "shortest paths"
        ]
    },
    {
        contestId: 1203,
        index: "F2",
        name: "Complete the Projects (hard version)",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1202,
        index: "C",
        name: "You Are Given a WASD-string...",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "greedy",
            "implementation",
            "math",
            "strings"
        ]
    },
    {
        contestId: 1202,
        index: "B",
        name: "You Are Given a Decimal String...",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "brute force",
            "dp",
            "shortest paths"
        ]
    },
    {
        contestId: 1201,
        index: "D",
        name: "Treasure Hunting",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "binary search",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1200,
        index: "F",
        name: "Graph Traveler",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "brute force",
            "data structures",
            "dfs and similar",
            "dp",
            "graphs",
            "implementation",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1200,
        index: "D",
        name: "White Lines",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 1200,
        index: "B",
        name: "Block Adventure",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1200,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1198,
        index: "D",
        name: "Rectangle Painting 1",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2300,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1197,
        index: "F",
        name: "Coloring Game",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "dp",
            "games",
            "matrices"
        ]
    },
    {
        contestId: 1197,
        index: "E",
        name: "Culture Code",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "binary search",
            "combinatorics",
            "data structures",
            "dp",
            "shortest paths",
            "sortings"
        ]
    },
    {
        contestId: 1197,
        index: "D",
        name: "Yet Another Subarray Problem",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1196,
        index: "D2",
        name: "RGB Substring (hard version)",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "data structures",
            "dp",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 1195,
        index: "C",
        name: "Basketball Exercise",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1194,
        index: "G",
        name: "Another Meme Problem",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1194,
        index: "F",
        name: "Crossword Expert",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "combinatorics",
            "dp",
            "number theory",
            "probabilities",
            "two pointers"
        ]
    },
    {
        contestId: 1193,
        index: "B",
        name: "Magic Tree",
        type: "PROGRAMMING",
        tags: [
            "*special",
            "data structures",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1193,
        index: "A",
        name: "Amusement Park",
        type: "PROGRAMMING",
        tags: [
            "*special",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1192,
        index: "C",
        name: "Cubeword",
        type: "PROGRAMMING",
        tags: [
            "*special",
            "brute force",
            "dp",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 1189,
        index: "C",
        name: "Candies!",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1400,
        tags: [
            "data structures",
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1188,
        index: "D",
        name: "Make Equal",
        type: "PROGRAMMING",
        points: 2250,
        rating: 3100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1188,
        index: "C",
        name: "Array Beauty",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1187,
        index: "F",
        name: "Expected Square Beauty",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1187,
        index: "E",
        name: "Tree Painting",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1185,
        index: "G2",
        name: "Playlist for Polycarp (hard version)",
        type: "PROGRAMMING",
        points: 750,
        rating: 2600,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 1185,
        index: "G1",
        name: "Playlist for Polycarp (easy version)",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2100,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 1183,
        index: "H",
        name: "Subsequences (hard version)",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1183,
        index: "E",
        name: "Subsequences (easy version)",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp",
            "graphs",
            "implementation",
            "shortest paths"
        ]
    },
    {
        contestId: 1182,
        index: "E",
        name: "Product Oriented Recurrence",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "dp",
            "math",
            "matrices",
            "number theory"
        ]
    },
    {
        contestId: 1182,
        index: "D",
        name: "Complete Mirror",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "hashing",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 1182,
        index: "A",
        name: "Filling Shapes",
        type: "PROGRAMMING",
        points: 500,
        rating: 1000,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 1181,
        index: "C",
        name: "Flag",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "brute force",
            "combinatorics",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1180,
        index: "A",
        name: "Alex and a Rhombus",
        type: "PROGRAMMING",
        points: 500,
        rating: 800,
        tags: [
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1179,
        index: "D",
        name: "Fedor Runs for President",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2700,
        tags: [
            "data structures",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1178,
        index: "F2",
        name: "Long Colorful Strip",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2600,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1178,
        index: "F1",
        name: "Short Colorful Strip",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2200,
        tags: [
            "combinatorics",
            "dfs and similar",
            "dp"
        ]
    },
    {
        contestId: 1178,
        index: "B",
        name: "WOW Factor",
        type: "PROGRAMMING",
        points: 750,
        rating: 1300,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1176,
        index: "F",
        name: "Destroy it!",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 1176,
        index: "C",
        name: "Lose it!",
        type: "PROGRAMMING",
        rating: 1300,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1175,
        index: "G",
        name: "Yet Another Partiton Problem",
        type: "PROGRAMMING",
        rating: 3000,
        tags: [
            "data structures",
            "divide and conquer",
            "dp",
            "geometry",
            "two pointers"
        ]
    },
    {
        contestId: 1175,
        index: "E",
        name: "Minimal Segment Cover",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "data structures",
            "dfs and similar",
            "divide and conquer",
            "dp",
            "greedy",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 1174,
        index: "E",
        name: "Ehab and the Expected GCD Problem",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1172,
        index: "C2",
        name: "Nauuo and Pictures (hard version)",
        type: "PROGRAMMING",
        points: 750,
        rating: 2600,
        tags: [
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 1172,
        index: "C1",
        name: "Nauuo and Pictures (easy version)",
        type: "PROGRAMMING",
        points: 750,
        rating: 2300,
        tags: [
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 1172,
        index: "B",
        name: "Nauuo and Circle",
        type: "PROGRAMMING",
        points: 750,
        rating: 1900,
        tags: [
            "combinatorics",
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1170,
        index: "I",
        name: "Good Subsets",
        type: "PROGRAMMING",
        tags: [
            "*special",
            "dp"
        ]
    },
    {
        contestId: 1168,
        index: "D",
        name: "Anagram Paths",
        type: "PROGRAMMING",
        points: 2000,
        rating: 3000,
        tags: [
            "dp",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 1168,
        index: "C",
        name: "And Reachability",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2200,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 1163,
        index: "D",
        name: "Mysterious Code",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2100,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1158,
        index: "F",
        name: "Density of subarrays",
        type: "PROGRAMMING",
        points: 2750,
        rating: 3500,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 1157,
        index: "F",
        name: "Maximum Balanced Circle",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 1156,
        index: "F",
        name: "Card Bag",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1156,
        index: "D",
        name: "0-1-Tree",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dfs and similar",
            "divide and conquer",
            "dp",
            "dsu",
            "trees"
        ]
    },
    {
        contestId: 1155,
        index: "F",
        name: "Delivery Oligopoly",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "brute force",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 1155,
        index: "D",
        name: "Beautiful Array",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "brute force",
            "data structures",
            "divide and conquer",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1154,
        index: "F",
        name: "Shovels Shop",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 1153,
        index: "F",
        name: "Serval and Bonus Problem",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2600,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1153,
        index: "D",
        name: "Serval and Rooted Tree",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1900,
        tags: [
            "binary search",
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1152,
        index: "F2",
        name: "Neko Rules the Catniverse (Large Version)",
        type: "PROGRAMMING",
        points: 750,
        rating: 3000,
        tags: [
            "bitmasks",
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 1152,
        index: "F1",
        name: "Neko Rules the Catniverse (Small Version)",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2800,
        tags: [
            "bitmasks",
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 1152,
        index: "D",
        name: "Neko and Aki's Prank",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1151,
        index: "F",
        name: "Sonya and Informatics",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2300,
        tags: [
            "combinatorics",
            "dp",
            "matrices",
            "probabilities"
        ]
    },
    {
        contestId: 1151,
        index: "E",
        name: "Number of Components",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2100,
        tags: [
            "combinatorics",
            "data structures",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1151,
        index: "B",
        name: "Dima and a Bad XOR",
        type: "PROGRAMMING",
        points: 750,
        rating: 1600,
        tags: [
            "bitmasks",
            "brute force",
            "constructive algorithms",
            "dp"
        ]
    },
    {
        contestId: 1149,
        index: "D",
        name: "Abandoning Roads",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "brute force",
            "dp",
            "graphs",
            "greedy"
        ]
    },
    {
        contestId: 1149,
        index: "B",
        name: "Three Religions",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2200,
        tags: [
            "dp",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 1146,
        index: "H",
        name: "Satanic Panic",
        type: "PROGRAMMING",
        points: 3750,
        rating: 2900,
        tags: [
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 1146,
        index: "G",
        name: "Zoning Restrictions",
        type: "PROGRAMMING",
        points: 3250,
        rating: 2700,
        tags: [
            "dp",
            "flows",
            "graphs"
        ]
    },
    {
        contestId: 1146,
        index: "F",
        name: "Leaf Partition",
        type: "PROGRAMMING",
        points: 3250,
        rating: 2500,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1144,
        index: "G",
        name: "Two Merged Sequences",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1142,
        index: "D",
        name: "Foreigner",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1142,
        index: "B",
        name: "Lynyrd Skynyrd",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2000,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "math",
            "trees"
        ]
    },
    {
        contestId: 1140,
        index: "E",
        name: "Palindrome-less Arrays",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "combinatorics",
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 1140,
        index: "D",
        name: "Minimum Triangulation",
        type: "PROGRAMMING",
        rating: 1200,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1139,
        index: "D",
        name: "Steps to One",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "dp",
            "math",
            "number theory",
            "probabilities"
        ]
    },
    {
        contestId: 1137,
        index: "C",
        name: "Museums Tour",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2500,
        tags: [
            "dp",
            "graphs",
            "implementation"
        ]
    },
    {
        contestId: 1133,
        index: "E",
        name: "K Balanced Teams",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 1132,
        index: "G",
        name: "Greedy Subsequences",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "data structures",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1132,
        index: "F",
        name: "Clear the String",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1132,
        index: "E",
        name: "Knapsack",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dfs and similar",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1131,
        index: "G",
        name: "Most Dangerous Shark",
        type: "PROGRAMMING",
        points: 3500,
        rating: 2700,
        tags: [
            "data structures",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 1131,
        index: "E",
        name: "String Multiplication",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "dp",
            "greedy",
            "strings"
        ]
    },
    {
        contestId: 1131,
        index: "D",
        name: "Gourmet choice",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "dfs and similar",
            "dp",
            "dsu",
            "graphs",
            "greedy"
        ]
    },
    {
        contestId: 1129,
        index: "D",
        name: "Isolation",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2900,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1129,
        index: "C",
        name: "Morse Code",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2400,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "hashing",
            "sortings",
            "string suffix structures",
            "strings"
        ]
    },
    {
        contestId: 1120,
        index: "F",
        name: "Secret Letters",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3100,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1120,
        index: "D",
        name: "Power Tree",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "dfs and similar",
            "dp",
            "dsu",
            "graphs",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1120,
        index: "C",
        name: "Compress String",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1119,
        index: "F",
        name: "Niyaz and Small Degrees",
        type: "PROGRAMMING",
        points: 3250,
        rating: 3400,
        tags: [
            "data structures",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1119,
        index: "E",
        name: "Pavel and Triangles",
        type: "PROGRAMMING",
        points: 2500,
        rating: 1900,
        tags: [
            "brute force",
            "dp",
            "fft",
            "greedy",
            "ternary search"
        ]
    },
    {
        contestId: 1118,
        index: "F2",
        name: "Tree Cutting (Hard Version)",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "combinatorics",
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1117,
        index: "F",
        name: "Crisp String",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 1117,
        index: "D",
        name: "Magic Gems",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "math",
            "matrices"
        ]
    },
    {
        contestId: 1114,
        index: "D",
        name: "Flood Fill",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1113,
        index: "A",
        name: "Sasha and His Trip",
        type: "PROGRAMMING",
        points: 500,
        rating: 900,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1111,
        index: "E",
        name: "Tree",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 1111,
        index: "D",
        name: "Destroy the Colony",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1110,
        index: "H",
        name: "Modest Substrings",
        type: "PROGRAMMING",
        points: 4000,
        rating: 3500,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1110,
        index: "D",
        name: "Jongmah",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1109,
        index: "D",
        name: "Sasha and Interesting Fact from Graph Theory",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2400,
        tags: [
            "brute force",
            "combinatorics",
            "dp",
            "math",
            "trees"
        ]
    },
    {
        contestId: 1109,
        index: "A",
        name: "Sasha and a Bit of Relax",
        type: "PROGRAMMING",
        points: 500,
        rating: 1600,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1108,
        index: "D",
        name: "Diverse Garland",
        type: "PROGRAMMING",
        rating: 1400,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1107,
        index: "G",
        name: "Vasya and Maximum Profit",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "binary search",
            "constructive algorithms",
            "data structures",
            "dp",
            "dsu"
        ]
    },
    {
        contestId: 1107,
        index: "F",
        name: "Vasya and Endless Credits",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "dp",
            "flows",
            "graph matchings",
            "graphs",
            "sortings"
        ]
    },
    {
        contestId: 1107,
        index: "E",
        name: "Vasya and Binary String",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1107,
        index: "D",
        name: "Compression",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp",
            "implementation",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1106,
        index: "E",
        name: "Lunar New Year and Red Envelopes",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2100,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1105,
        index: "E",
        name: "Helping Hiasat ",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 1105,
        index: "C",
        name: "Ayoub and Lost Array",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1103,
        index: "D",
        name: "Professional layer",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3100,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 1102,
        index: "F",
        name: "Elongated Matrix",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "binary search",
            "bitmasks",
            "brute force",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 1101,
        index: "F",
        name: "Trucks and Cities",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 1101,
        index: "D",
        name: "GCD Counting",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "number theory",
            "trees"
        ]
    },
    {
        contestId: 1099,
        index: "F",
        name: "Cookies",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2400,
        tags: [
            "binary search",
            "data structures",
            "dfs and similar",
            "dp",
            "games",
            "trees"
        ]
    },
    {
        contestId: 1097,
        index: "H",
        name: "Mateusz and an Infinite Sequence",
        type: "PROGRAMMING",
        points: 4000,
        rating: 3400,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1097,
        index: "G",
        name: "Vladislav and a Great Legend",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3000,
        tags: [
            "combinatorics",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1097,
        index: "D",
        name: "Makoto and a Blackboard",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "dp",
            "math",
            "number theory",
            "probabilities"
        ]
    },
    {
        contestId: 1097,
        index: "B",
        name: "Petr and a Combination Lock",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1200,
        tags: [
            "bitmasks",
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 1096,
        index: "G",
        name: "Lucky Tickets",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "divide and conquer",
            "dp",
            "fft"
        ]
    },
    {
        contestId: 1096,
        index: "F",
        name: "Inversion Expectation",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1096,
        index: "E",
        name: "The Top Scorer",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1096,
        index: "D",
        name: "Easy Problem",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1093,
        index: "F",
        name: "Vasya and Array",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1092,
        index: "F",
        name: "Tree with Maximum Cost",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1091,
        index: "D",
        name: "New Year and the Permutation Concatenation",
        type: "PROGRAMMING",
        points: 2250,
        rating: 1700,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1089,
        index: "A",
        name: "Alice the Fan",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1088,
        index: "E",
        name: "Ehab and a component choosing problem",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "dp",
            "greedy",
            "math",
            "trees"
        ]
    },
    {
        contestId: 1085,
        index: "G",
        name: "Beautiful Matrix",
        type: "PROGRAMMING",
        points: 3250,
        rating: 2900,
        tags: [
            "combinatorics",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1084,
        index: "C",
        name: "The Fair Nut and String",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "combinatorics",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1083,
        index: "E",
        name: "The Fair Nut and Rectangles",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "data structures",
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 1083,
        index: "A",
        name: "The Fair Nut and the Best Path",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "data structures",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1082,
        index: "F",
        name: "Speed Dial",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "dp",
            "strings",
            "trees"
        ]
    },
    {
        contestId: 1082,
        index: "E",
        name: "Increasing Frequency",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "binary search",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1081,
        index: "C",
        name: "Colorful Bricks",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1077,
        index: "F2",
        name: "Pictures with Kittens (hard version)",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 1077,
        index: "F1",
        name: "Pictures with Kittens (easy version)",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1076,
        index: "F",
        name: "Summer Practice Report",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1073,
        index: "F",
        name: "Choosing Two Paths",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1073,
        index: "E",
        name: "Segment Sum",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1070,
        index: "J",
        name: "Streets and Avenues in Berhattan",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1070,
        index: "G",
        name: "Monsters and Potions",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1070,
        index: "A",
        name: "Find a Number",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dp",
            "graphs",
            "number theory",
            "shortest paths"
        ]
    },
    {
        contestId: 1067,
        index: "E",
        name: "Random Forest Rank",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2800,
        tags: [
            "dp",
            "graph matchings",
            "math",
            "trees"
        ]
    },
    {
        contestId: 1067,
        index: "D",
        name: "Computer Game",
        type: "PROGRAMMING",
        points: 2250,
        rating: 3100,
        tags: [
            "dp",
            "greedy",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1067,
        index: "A",
        name: "Array Without Local Maximums ",
        type: "PROGRAMMING",
        points: 500,
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1066,
        index: "F",
        name: "Yet another 2D Walking",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1065,
        index: "F",
        name: "Up and Down the Tree",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1065,
        index: "D",
        name: "Three Pieces",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dfs and similar",
            "dp",
            "shortest paths"
        ]
    },
    {
        contestId: 1063,
        index: "F",
        name: "String Journey",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3300,
        tags: [
            "data structures",
            "dp",
            "string suffix structures"
        ]
    },
    {
        contestId: 1061,
        index: "C",
        name: "Multiplicity",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "data structures",
            "dp",
            "implementation",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 1060,
        index: "F",
        name: "Shrinking Tree",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2900,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 1060,
        index: "E",
        name: "Sergey and Subway",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2000,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1059,
        index: "E",
        name: "Split the Tree",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 1057,
        index: "C",
        name: "Tanya and Colored Candies",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "*special",
            "dp"
        ]
    },
    {
        contestId: 1056,
        index: "F",
        name: "Write The Contest",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2500,
        tags: [
            "binary search",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1056,
        index: "D",
        name: "Decorate Apple Tree",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1600,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "graphs",
            "greedy",
            "sortings",
            "trees"
        ]
    },
    {
        contestId: 1055,
        index: "E",
        name: "Segments on the Line",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2500,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 1051,
        index: "E",
        name: "Vasya and Big Integers",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "hashing",
            "strings"
        ]
    },
    {
        contestId: 1051,
        index: "D",
        name: "Bicolorings",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 1051,
        index: "C",
        name: "Vasya and Multisets",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 1044,
        index: "C",
        name: "Optimal Polygon Perimeter",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 1043,
        index: "F",
        name: "Make It One",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2500,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "math",
            "number theory",
            "shortest paths"
        ]
    },
    {
        contestId: 1042,
        index: "E",
        name: "Vasya and Magic Matrix",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 1042,
        index: "B",
        name: "Vitamins",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1200,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1041,
        index: "F",
        name: "Ray in the tube",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2500,
        tags: [
            "data structures",
            "divide and conquer",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1040,
        index: "B",
        name: "Shashlik Cooking",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1300,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1039,
        index: "D",
        name: "You Are Given a Tree",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2800,
        tags: [
            "data structures",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1038,
        index: "F",
        name: "Wrap Around",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2900,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1038,
        index: "E",
        name: "Maximum Matching",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2400,
        tags: [
            "bitmasks",
            "brute force",
            "dfs and similar",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 1038,
        index: "D",
        name: "Slime",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1800,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 1037,
        index: "C",
        name: "Equalize",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1300,
        tags: [
            "dp",
            "greedy",
            "strings"
        ]
    },
    {
        contestId: 1036,
        index: "C",
        name: "Classy Numbers",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 1034,
        index: "E",
        name: "Little C Loves 3 III",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3200,
        tags: [
            "bitmasks",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1034,
        index: "C",
        name: "Region Separation",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2700,
        tags: [
            "combinatorics",
            "dp",
            "number theory",
            "trees"
        ]
    },
    {
        contestId: 1033,
        index: "C",
        name: "Permutation Game",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1600,
        tags: [
            "brute force",
            "dp",
            "games"
        ]
    },
    {
        contestId: 1032,
        index: "F",
        name: "Vasya and Maximum Matching",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2400,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1032,
        index: "E",
        name: "The Unbearable Lightness of Weights",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 1032,
        index: "C",
        name: "Playing Piano",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "constructive algorithms",
            "dp"
        ]
    },
    {
        contestId: 1030,
        index: "E",
        name: "Vasya and Good Sequences",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 1029,
        index: "E",
        name: "Tree with Small Distances",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "graphs",
            "greedy"
        ]
    },
    {
        contestId: 1029,
        index: "B",
        name: "Creating the Contest",
        type: "PROGRAMMING",
        rating: 1200,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 1028,
        index: "G",
        name: "Guess the number",
        type: "PROGRAMMING",
        points: 3250,
        rating: 3000,
        tags: [
            "dp",
            "interactive"
        ]
    },
    {
        contestId: 1027,
        index: "E",
        name: "Inverse Coloring",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 1025,
        index: "D",
        name: "Recovering BST",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2100,
        tags: [
            "brute force",
            "dp",
            "math",
            "number theory",
            "trees"
        ]
    },
    {
        contestId: 1016,
        index: "F",
        name: "Road Projects",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1016,
        index: "C",
        name: "Vasya And The Mushrooms",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1015,
        index: "F",
        name: "Bracket Substring",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 1015,
        index: "E2",
        name: "Stars Drawing (Hard Edition)",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "binary search",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1015,
        index: "E1",
        name: "Stars Drawing (Easy Edition)",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 1012,
        index: "F",
        name: "Passports",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3400,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 1012,
        index: "C",
        name: "Hills",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1007,
        index: "E",
        name: "Mini Metro",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 1006,
        index: "F",
        name: "Xor-Paths",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 1005,
        index: "D",
        name: "Polycarp and Div 3",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "dp",
            "greedy",
            "number theory"
        ]
    },
    {
        contestId: 1004,
        index: "E",
        name: "Sonya and Ice Cream",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "shortest paths",
            "trees"
        ]
    },
    {
        contestId: 1003,
        index: "F",
        name: "Abbreviation",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dp",
            "hashing",
            "strings"
        ]
    },
    {
        contestId: 1000,
        index: "G",
        name: "Two-Paths",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "data structures",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 1000,
        index: "D",
        name: "Yet Another Problem On a Subsequence",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 999,
        index: "F",
        name: "Cards and Joy",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 998,
        index: "B",
        name: "Cutting",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1200,
        tags: [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 997,
        index: "B",
        name: "Roman Digits",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2000,
        tags: [
            "brute force",
            "combinatorics",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 996,
        index: "A",
        name: "Hit the Lottery",
        type: "PROGRAMMING",
        points: 500,
        rating: 800,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 995,
        index: "F",
        name: "Cowmpany Cowmpensation",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "trees"
        ]
    },
    {
        contestId: 993,
        index: "D",
        name: "Compute Power",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2500,
        tags: [
            "binary search",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 991,
        index: "D",
        name: "Bishwock",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 990,
        index: "G",
        name: "GCD Counting",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "divide and conquer",
            "dp",
            "dsu",
            "number theory",
            "trees"
        ]
    },
    {
        contestId: 990,
        index: "F",
        name: "Flow Control",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 989,
        index: "E",
        name: "A Trance of Nightfall",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "dp",
            "geometry",
            "matrices",
            "probabilities"
        ]
    },
    {
        contestId: 988,
        index: "F",
        name: "Rain and Umbrellas",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 987,
        index: "C",
        name: "Three displays",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1400,
        tags: [
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 985,
        index: "E",
        name: "Pencils and Boxes",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 983,
        index: "C",
        name: "Elevator",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2400,
        tags: [
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 983,
        index: "B",
        name: "XOR-pyramid",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 982,
        index: "C",
        name: "Cut 'em all!",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 981,
        index: "H",
        name: "K Paths",
        type: "PROGRAMMING",
        points: 3750,
        rating: 3100,
        tags: [
            "combinatorics",
            "data structures",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 981,
        index: "E",
        name: "Addition on Segments",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2200,
        tags: [
            "bitmasks",
            "data structures",
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 981,
        index: "D",
        name: "Bookshelves",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1900,
        tags: [
            "bitmasks",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 980,
        index: "F",
        name: "Cactus to Tree",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2900,
        tags: [
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 980,
        index: "D",
        name: "Perfect Groups",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 979,
        index: "E",
        name: "Kuro and Topological Parity",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 979,
        index: "D",
        name: "Kuro and GCD and XOR and SUM",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2200,
        tags: [
            "binary search",
            "bitmasks",
            "brute force",
            "data structures",
            "dp",
            "dsu",
            "greedy",
            "math",
            "number theory",
            "strings",
            "trees"
        ]
    },
    {
        contestId: 977,
        index: "F",
        name: "Consecutive Subsequence",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 965,
        index: "E",
        name: "Short Code",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "strings",
            "trees"
        ]
    },
    {
        contestId: 963,
        index: "B",
        name: "Destruction of a Tree",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2000,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 961,
        index: "B",
        name: "Lecture Sleep",
        type: "PROGRAMMING",
        rating: 1200,
        tags: [
            "data structures",
            "dp",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 960,
        index: "G",
        name: "Bandit Blues",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2900,
        tags: [
            "combinatorics",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 960,
        index: "F",
        name: "Pathwalks",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "data structures",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 960,
        index: "E",
        name: "Alternating Tree",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "combinatorics",
            "dfs and similar",
            "divide and conquer",
            "dp",
            "probabilities",
            "trees"
        ]
    },
    {
        contestId: 959,
        index: "F",
        name: "Mahmoud and Ehab and yet another xor task",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "bitmasks",
            "dp",
            "math",
            "matrices"
        ]
    },
    {
        contestId: 959,
        index: "E",
        name: "Mahmoud and Ehab and the xor-MST",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "bitmasks",
            "dp",
            "graphs",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 958,
        index: "E2",
        name: "Guard Duty (medium)",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "binary search",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 958,
        index: "C3",
        name: "Encryption (hard)",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 958,
        index: "C2",
        name: "Encryption (medium)",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 955,
        index: "F",
        name: "Heaps",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2600,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 954,
        index: "H",
        name: "Path Counting",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 954,
        index: "F",
        name: "Runner's Problem",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "matrices",
            "sortings"
        ]
    },
    {
        contestId: 946,
        index: "G",
        name: "Almost Increasing Array",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 946,
        index: "F",
        name: "Fibonacci String Subsequences",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "combinatorics",
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 946,
        index: "D",
        name: "Timetable",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 940,
        index: "E",
        name: "Cashback",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 940,
        index: "B",
        name: "Our Tanya is Crying Out Loud",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1400,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 939,
        index: "F",
        name: "Cutlet",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2400,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 938,
        index: "F",
        name: "Erasing Substrings",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "bitmasks",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 936,
        index: "D",
        name: "World of Tank",
        type: "PROGRAMMING",
        points: 2000,
        rating: 3000,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 936,
        index: "B",
        name: "Sleepy Game",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "games",
            "graphs"
        ]
    },
    {
        contestId: 935,
        index: "E",
        name: "Fafa and Ancient Mathematics",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 933,
        index: "E",
        name: "A Preponderant Reunion",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3200,
        tags: [
            "constructive algorithms",
            "dp"
        ]
    },
    {
        contestId: 933,
        index: "A",
        name: "A Twisty Movement",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 932,
        index: "G",
        name: "Palindrome Partition",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2900,
        tags: [
            "dp",
            "string suffix structures",
            "strings"
        ]
    },
    {
        contestId: 932,
        index: "F",
        name: "Escape Through Leaf",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "data structures",
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 932,
        index: "E",
        name: "Team Work",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 932,
        index: "D",
        name: "Tree",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "binary search",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 930,
        index: "E",
        name: "Coins Exhibition",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2900,
        tags: [
            "data structures",
            "dp",
            "math"
        ]
    },
    {
        contestId: 930,
        index: "C",
        name: "Teodor is not a liar!",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 928,
        index: "B",
        name: "Chat",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1400,
        tags: [
            "*special",
            "dp"
        ]
    },
    {
        contestId: 924,
        index: "F",
        name: "Minimal Subset Difference",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3200,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 924,
        index: "C",
        name: "Riverside Curio",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1700,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 922,
        index: "F",
        name: "Divisibility",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2400,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy",
            "number theory"
        ]
    },
    {
        contestId: 922,
        index: "E",
        name: "Birds",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 920,
        index: "D",
        name: "Tanks",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 919,
        index: "D",
        name: "Substring",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "dfs and similar",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 919,
        index: "B",
        name: "Perfect Number",
        type: "PROGRAMMING",
        points: 750,
        rating: 1100,
        tags: [
            "binary search",
            "brute force",
            "dp",
            "implementation",
            "number theory"
        ]
    },
    {
        contestId: 917,
        index: "D",
        name: "Stranger Trees",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "dp",
            "math",
            "matrices",
            "trees"
        ]
    },
    {
        contestId: 917,
        index: "C",
        name: "Pollywog",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2900,
        tags: [
            "combinatorics",
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 917,
        index: "B",
        name: "MADMAX",
        type: "PROGRAMMING",
        points: 750,
        rating: 1700,
        tags: [
            "dfs and similar",
            "dp",
            "games",
            "graphs"
        ]
    },
    {
        contestId: 917,
        index: "A",
        name: "The Monster",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "dp",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 915,
        index: "C",
        name: "Permute Digits",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 914,
        index: "H",
        name: "Ember and Storm's Tree Game",
        type: "PROGRAMMING",
        points: 3750,
        rating: 3400,
        tags: [
            "combinatorics",
            "dp",
            "games",
            "trees"
        ]
    },
    {
        contestId: 914,
        index: "G",
        name: "Sum the Fibonacci",
        type: "PROGRAMMING",
        points: 3500,
        rating: 2600,
        tags: [
            "bitmasks",
            "divide and conquer",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 914,
        index: "C",
        name: "Travelling Salesman and Special Numbers",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1800,
        tags: [
            "brute force",
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 913,
        index: "F",
        name: "Strongly Connected Tournament",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2800,
        tags: [
            "dp",
            "graphs",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 913,
        index: "E",
        name: "Logical Expression",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2400,
        tags: [
            "bitmasks",
            "dp",
            "shortest paths"
        ]
    },
    {
        contestId: 913,
        index: "C",
        name: "Party Lemonade",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1600,
        tags: [
            "bitmasks",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 910,
        index: "A",
        name: "The Way to Home",
        type: "PROGRAMMING",
        points: 500,
        rating: 800,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 909,
        index: "E",
        name: "Coprocessor",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "greedy"
        ]
    },
    {
        contestId: 909,
        index: "C",
        name: "Python Indentation",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 908,
        index: "G",
        name: "New Year and Original Order",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2800,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 908,
        index: "E",
        name: "New Year and Entity Enumeration",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2500,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 908,
        index: "D",
        name: "New Year and Arbitrary Arrangement",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2200,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 906,
        index: "E",
        name: "Reverses",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3300,
        tags: [
            "dp",
            "string suffix structures",
            "strings"
        ]
    },
    {
        contestId: 906,
        index: "C",
        name: "Party",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2400,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 903,
        index: "F",
        name: "Clear The Matrix",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 900,
        index: "E",
        name: "Maximum Questions",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "data structures",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 900,
        index: "D",
        name: "Unusual Sequences",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 895,
        index: "C",
        name: "Square Subsets",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2000,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 894,
        index: "E",
        name: "Ralph and Mushrooms",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 894,
        index: "A",
        name: "QAQ",
        type: "PROGRAMMING",
        points: 500,
        rating: 800,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 893,
        index: "E",
        name: "Counting Arrays",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 893,
        index: "D",
        name: "Credit Card",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 891,
        index: "D",
        name: "Sloth",
        type: "PROGRAMMING",
        points: 2000,
        rating: 3100,
        tags: [
            "dfs and similar",
            "dp",
            "graph matchings",
            "trees"
        ]
    },
    {
        contestId: 891,
        index: "A",
        name: "Pride",
        type: "PROGRAMMING",
        points: 500,
        rating: 1500,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 889,
        index: "E",
        name: "Mod Mod Mod",
        type: "PROGRAMMING",
        points: 2250,
        rating: 3000,
        tags: [
            "binary search",
            "dp",
            "math"
        ]
    },
    {
        contestId: 888,
        index: "F",
        name: "Connecting Vertices",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 888,
        index: "D",
        name: "Almost Identity Permutations",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 886,
        index: "E",
        name: "Maximum Element",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 883,
        index: "I",
        name: "Photo Processing",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 883,
        index: "D",
        name: "Packmen Strike Back",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "binary search",
            "dp",
            "math"
        ]
    },
    {
        contestId: 878,
        index: "E",
        name: "Numbers on the blackboard",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3300,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 877,
        index: "B",
        name: "Nikita and string",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1500,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 875,
        index: "E",
        name: "Delivery Club",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "binary search",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 873,
        index: "E",
        name: "Awards For Contestants",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "brute force",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 873,
        index: "B",
        name: "Balanced Substring",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 870,
        index: "C",
        name: "Maximum splitting",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1300,
        tags: [
            "dp",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 869,
        index: "C",
        name: "The Intriguing Obsession",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1800,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 868,
        index: "F",
        name: "Yet Another Minimization Problem",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 868,
        index: "E",
        name: "Policeman and a Tree",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2700,
        tags: [
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 868,
        index: "D",
        name: "Huge Strings",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2200,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 868,
        index: "C",
        name: "Qualification Rounds",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1500,
        tags: [
            "bitmasks",
            "brute force",
            "constructive algorithms",
            "dp"
        ]
    },
    {
        contestId: 865,
        index: "E",
        name: "Hex Dyslexia",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3300,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 865,
        index: "C",
        name: "Gotta Go Fast",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2400,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 864,
        index: "E",
        name: "Fire",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2000,
        tags: [
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 859,
        index: "D",
        name: "Third Month Insanity",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "dp",
            "probabilities",
            "trees"
        ]
    },
    {
        contestId: 859,
        index: "C",
        name: "Pie Rules",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1500,
        tags: [
            "dp",
            "games"
        ]
    },
    {
        contestId: 858,
        index: "C",
        name: "Did you mean...",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 856,
        index: "D",
        name: "Masha and Cactus",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 856,
        index: "C",
        name: "Eleventh Birthday",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 856,
        index: "B",
        name: "Similar Words",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp",
            "hashing",
            "strings",
            "trees"
        ]
    },
    {
        contestId: 855,
        index: "G",
        name: "Harry Vs Voldemort",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3300,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 855,
        index: "E",
        name: "Salazar Slytherin's Locket",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 855,
        index: "C",
        name: "Helga Hufflepuff's Cup",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 855,
        index: "B",
        name: "Marvolo Gaunt's Ring",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1500,
        tags: [
            "brute force",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 853,
        index: "D",
        name: "Michael and Charging Stations",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2400,
        tags: [
            "binary search",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 852,
        index: "H",
        name: "Bob and stages",
        type: "PROGRAMMING",
        rating: 3000,
        tags: [
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 852,
        index: "E",
        name: "Casinos and travel",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 852,
        index: "B",
        name: "Neural Network country",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 850,
        index: "D",
        name: "Tournament Construction",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2800,
        tags: [
            "constructive algorithms",
            "dp",
            "graphs",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 850,
        index: "C",
        name: "Arpa and a game with Mojtaba",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2200,
        tags: [
            "bitmasks",
            "dp",
            "games"
        ]
    },
    {
        contestId: 848,
        index: "E",
        name: "Days of Floral Colours",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3400,
        tags: [
            "combinatorics",
            "divide and conquer",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 848,
        index: "D",
        name: "Shake It!",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2900,
        tags: [
            "combinatorics",
            "dp",
            "flows",
            "graphs"
        ]
    },
    {
        contestId: 847,
        index: "E",
        name: "Packmen",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 846,
        index: "C",
        name: "Four Segments",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "brute force",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 845,
        index: "F",
        name: "Guards In The Storehouse",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 845,
        index: "D",
        name: "Driving Test",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 840,
        index: "C",
        name: "On the Bench",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2500,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 840,
        index: "B",
        name: "Leha and another game about graph",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2100,
        tags: [
            "constructive algorithms",
            "data structures",
            "dfs and similar",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 839,
        index: "D",
        name: "Winter is here",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 839,
        index: "C",
        name: "Journey",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "probabilities",
            "trees"
        ]
    },
    {
        contestId: 838,
        index: "E",
        name: "Convex Countour",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 838,
        index: "C",
        name: "Future Failure",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "dp",
            "games"
        ]
    },
    {
        contestId: 837,
        index: "D",
        name: "Round Subset",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 835,
        index: "F",
        name: "Roads in the Kingdom",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2500,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 835,
        index: "D",
        name: "Palindromic characteristics",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "brute force",
            "dp",
            "hashing",
            "strings"
        ]
    },
    {
        contestId: 835,
        index: "C",
        name: "Star sky",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1600,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 833,
        index: "E",
        name: "Caramel Clouds",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3400,
        tags: [
            "data structures",
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 833,
        index: "B",
        name: "The Bakery",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2200,
        tags: [
            "binary search",
            "data structures",
            "divide and conquer",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 830,
        index: "E",
        name: "Perpetual Motion Machine",
        type: "PROGRAMMING",
        points: 2250,
        rating: 3100,
        tags: [
            "constructive algorithms",
            "dp",
            "graphs",
            "implementation",
            "math",
            "trees"
        ]
    },
    {
        contestId: 830,
        index: "D",
        name: "Singer House",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2800,
        tags: [
            "combinatorics",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 830,
        index: "A",
        name: "Office Keys",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "binary search",
            "brute force",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 827,
        index: "F",
        name: "Dirty Arkady's Kitchen",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3200,
        tags: [
            "data structures",
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 825,
        index: "F",
        name: "String Compression",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "dp",
            "hashing",
            "string suffix structures",
            "strings"
        ]
    },
    {
        contestId: 822,
        index: "E",
        name: "Liar",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2400,
        tags: [
            "binary search",
            "dp",
            "hashing",
            "string suffix structures"
        ]
    },
    {
        contestId: 822,
        index: "D",
        name: "My pretty girl Noora",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1800,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 821,
        index: "E",
        name: "Okabe and El Psy Kongroo",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 817,
        index: "C",
        name: "Really Big Numbers",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "binary search",
            "brute force",
            "dp",
            "math"
        ]
    },
    {
        contestId: 815,
        index: "C",
        name: "Karen and Supermarket",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2400,
        tags: [
            "brute force",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 814,
        index: "E",
        name: "An unavoidable detour for home",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "combinatorics",
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 814,
        index: "D",
        name: "An overnight dance in discotheque",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2000,
        tags: [
            "dfs and similar",
            "dp",
            "geometry",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 814,
        index: "C",
        name: "An impassioned circulation of affection",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1600,
        tags: [
            "brute force",
            "dp",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 813,
        index: "D",
        name: "Two Melodies",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "dp",
            "flows"
        ]
    },
    {
        contestId: 812,
        index: "B",
        name: "Sagheer, the Hausmeister",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1600,
        tags: [
            "bitmasks",
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 811,
        index: "C",
        name: "Vladik and Memorable Trip",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 809,
        index: "D",
        name: "Hitchhiking in the Baltic States",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2900,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 809,
        index: "C",
        name: "Find a car",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2600,
        tags: [
            "combinatorics",
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 808,
        index: "G",
        name: "Anthem of Berland",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 808,
        index: "E",
        name: "Selling Souvenirs",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "binary search",
            "dp",
            "greedy",
            "ternary search"
        ]
    },
    {
        contestId: 804,
        index: "F",
        name: "Fake bullions",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3400,
        tags: [
            "combinatorics",
            "dfs and similar",
            "dp",
            "graphs",
            "number theory"
        ]
    },
    {
        contestId: 804,
        index: "D",
        name: "Expected diameter of a tree",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "binary search",
            "brute force",
            "dfs and similar",
            "dp",
            "sortings",
            "trees"
        ]
    },
    {
        contestId: 803,
        index: "E",
        name: "Roma and Poker",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 802,
        index: "L",
        name: "Send the Fool Further! (hard)",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "dfs and similar",
            "dp",
            "math",
            "trees"
        ]
    },
    {
        contestId: 802,
        index: "K",
        name: "Send the Fool Further! (medium)",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 799,
        index: "D",
        name: "Field expansion",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "brute force",
            "dp",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 798,
        index: "C",
        name: "Mike and gcd problem",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "dp",
            "greedy",
            "number theory"
        ]
    },
    {
        contestId: 798,
        index: "B",
        name: "Mike and strings",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1300,
        tags: [
            "brute force",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 797,
        index: "F",
        name: "Mice and Holes",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 797,
        index: "E",
        name: "Array Queries",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "brute force",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 797,
        index: "B",
        name: "Odd sum",
        type: "PROGRAMMING",
        rating: 1400,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 796,
        index: "E",
        name: "Exam Cheating",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 796,
        index: "D",
        name: "Police Stations",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "graphs",
            "shortest paths",
            "trees"
        ]
    },
    {
        contestId: 796,
        index: "C",
        name: "Bank Hacking",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "constructive algorithms",
            "data structures",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 794,
        index: "G",
        name: "Replace All",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3400,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 793,
        index: "F",
        name: "Julia the snail",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3000,
        tags: [
            "data structures",
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 793,
        index: "E",
        name: "Problem of offices",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2900,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 793,
        index: "D",
        name: "Presents in Bankopolis",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 792,
        index: "C",
        name: "Divide by Three",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 788,
        index: "A",
        name: "Functions again",
        type: "PROGRAMMING",
        points: 500,
        rating: 1600,
        tags: [
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 786,
        index: "A",
        name: "Berzerk",
        type: "PROGRAMMING",
        points: 750,
        rating: 2000,
        tags: [
            "dfs and similar",
            "dp",
            "games"
        ]
    },
    {
        contestId: 785,
        index: "D",
        name: "Anton and School - 2",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 780,
        index: "G",
        name: "Andryusha and Nervous Barriers",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2700,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 780,
        index: "F",
        name: "Axel and Marston in Bitland",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "bitmasks",
            "dp",
            "graphs",
            "matrices"
        ]
    },
    {
        contestId: 778,
        index: "E",
        name: "Selling Numbers",
        type: "PROGRAMMING",
        points: 2250,
        rating: 3000,
        tags: [
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 777,
        index: "E",
        name: "Hanoi Factory",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2000,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 777,
        index: "C",
        name: "Alyona and Spreadsheet",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1600,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 777,
        index: "B",
        name: "Game of Credit Cards",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1300,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 776,
        index: "G",
        name: "Sherlock and the Encrypted Data",
        type: "PROGRAMMING",
        points: 3250,
        rating: 2900,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 774,
        index: "J",
        name: "Stepan's Series",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "*special",
            "dp"
        ]
    },
    {
        contestId: 774,
        index: "I",
        name: "Composing Of String",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "*special",
            "dp"
        ]
    },
    {
        contestId: 773,
        index: "F",
        name: "Test Data Generation",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3400,
        tags: [
            "combinatorics",
            "divide and conquer",
            "dp",
            "fft",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 773,
        index: "D",
        name: "Perishable Roads",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 772,
        index: "D",
        name: "Varying Kibibits",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2700,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 772,
        index: "C",
        name: "Vulnerable Kerbals",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2300,
        tags: [
            "constructive algorithms",
            "dp",
            "graphs",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 771,
        index: "E",
        name: "Bear and Rectangle Strips",
        type: "PROGRAMMING",
        points: 2250,
        rating: 3000,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 771,
        index: "D",
        name: "Bear and Company",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 771,
        index: "C",
        name: "Bear and Tree Jumps",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 768,
        index: "E",
        name: "Game of Stones",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "bitmasks",
            "dp",
            "games"
        ]
    },
    {
        contestId: 768,
        index: "D",
        name: "Jon and Orbs",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2200,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 768,
        index: "C",
        name: "Jon Snow and his Favourite Number",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1800,
        tags: [
            "brute force",
            "dp",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 766,
        index: "E",
        name: "Mahmoud and a xor trip",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "bitmasks",
            "constructive algorithms",
            "data structures",
            "dfs and similar",
            "dp",
            "math",
            "trees"
        ]
    },
    {
        contestId: 766,
        index: "D",
        name: "Mahmoud and a Dictionary",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "dsu",
            "graphs"
        ]
    },
    {
        contestId: 766,
        index: "C",
        name: "Mahmoud and a Message",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "strings"
        ]
    },
    {
        contestId: 765,
        index: "G",
        name: "Math, math everywhere",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3200,
        tags: [
            "brute force",
            "dp",
            "math",
            "meet-in-the-middle",
            "number theory"
        ]
    },
    {
        contestId: 765,
        index: "E",
        name: "Tree Folding",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 763,
        index: "A",
        name: "Timofey and a tree",
        type: "PROGRAMMING",
        points: 500,
        rating: 1600,
        tags: [
            "dfs and similar",
            "dp",
            "dsu",
            "graphs",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 762,
        index: "D",
        name: "Maximum path",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 761,
        index: "F",
        name: "Dasha and Photos",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2600,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 761,
        index: "C",
        name: "Dasha and Password",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 758,
        index: "E",
        name: "Broken Tree",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 758,
        index: "D",
        name: "Ability To Convert",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2000,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy",
            "math",
            "strings"
        ]
    },
    {
        contestId: 757,
        index: "E",
        name: "Bash Plays with Functions",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "brute force",
            "combinatorics",
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 757,
        index: "D",
        name: "Felicity's Big Secret Revealed",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 756,
        index: "E",
        name: "Byteland coins",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3200,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 756,
        index: "D",
        name: "Bacterial Melee",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "brute force",
            "combinatorics",
            "dp",
            "string suffix structures"
        ]
    },
    {
        contestId: 756,
        index: "B",
        name: "Travel Card",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1600,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 755,
        index: "G",
        name: "PolandBall and Many Other Balls",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3200,
        tags: [
            "combinatorics",
            "divide and conquer",
            "dp",
            "fft",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 755,
        index: "F",
        name: "PolandBall and Gifts",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2600,
        tags: [
            "bitmasks",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 754,
        index: "C",
        name: "Vladik and chat",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2200,
        tags: [
            "brute force",
            "constructive algorithms",
            "dp",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 753,
        index: "A",
        name: "Santa Claus and Candies",
        type: "PROGRAMMING",
        points: 500,
        rating: 1000,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 750,
        index: "G",
        name: "New Year and Binary Tree Paths",
        type: "PROGRAMMING",
        points: 3250,
        rating: 3200,
        tags: [
            "bitmasks",
            "brute force",
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 750,
        index: "E",
        name: "New Year and Old Subsequence",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2600,
        tags: [
            "data structures",
            "divide and conquer",
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 750,
        index: "D",
        name: "New Year and Fireworks",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "brute force",
            "data structures",
            "dfs and similar",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 747,
        index: "F",
        name: "Igor and Interesting Numbers",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "brute force",
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 747,
        index: "D",
        name: "Winter Is Coming",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 744,
        index: "C",
        name: "Hongcow Buys a Deck of Cards",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2400,
        tags: [
            "bitmasks",
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 743,
        index: "E",
        name: "Vladik and cards",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "binary search",
            "bitmasks",
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 743,
        index: "D",
        name: "Chloe and pleasant prizes",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 741,
        index: "B",
        name: "Arpa's weak amphitheater and Mehrdad's valuable Hoses",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1600,
        tags: [
            "dfs and similar",
            "dp",
            "dsu"
        ]
    },
    {
        contestId: 739,
        index: "E",
        name: "Gosha is hunting",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "flows",
            "math",
            "probabilities",
            "sortings"
        ]
    },
    {
        contestId: 735,
        index: "E",
        name: "Ostap and Tree",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 734,
        index: "E",
        name: "Anton and Tree",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 734,
        index: "C",
        name: "Anton and Making Potions",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1600,
        tags: [
            "binary search",
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 733,
        index: "C",
        name: "Epidemic in Monstropolis",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 732,
        index: "B",
        name: "Cormen --- The Best Friend Of a Man",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1000,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 731,
        index: "E",
        name: "Funny Game",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "dp",
            "games"
        ]
    },
    {
        contestId: 730,
        index: "J",
        name: "Bottles",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 730,
        index: "I",
        name: "Olympiad in Programming and Sports",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp",
            "flows",
            "graphs",
            "greedy"
        ]
    },
    {
        contestId: 729,
        index: "F",
        name: "Financiers Game",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 729,
        index: "B",
        name: "Spotlights",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1200,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 727,
        index: "F",
        name: "Polycarp's problems",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2300,
        tags: [
            "binary search",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 724,
        index: "F",
        name: "Uniformly Branched Trees",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "combinatorics",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 724,
        index: "E",
        name: "Goods transportation",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2900,
        tags: [
            "dp",
            "flows",
            "greedy"
        ]
    },
    {
        contestId: 722,
        index: "E",
        name: "Research Rover",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2900,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 721,
        index: "E",
        name: "Road to Home",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2700,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 721,
        index: "C",
        name: "Journey",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1800,
        tags: [
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 720,
        index: "D",
        name: "Slalom",
        type: "PROGRAMMING",
        rating: 3100,
        tags: [
            "data structures",
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 718,
        index: "D",
        name: "Andrew and Chemistry",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2900,
        tags: [
            "dp",
            "hashing",
            "trees"
        ]
    },
    {
        contestId: 718,
        index: "A",
        name: "Efim and Strange Grade",
        type: "PROGRAMMING",
        points: 500,
        rating: 1700,
        tags: [
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 717,
        index: "B",
        name: "R3D3’s Summer Adventure",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 713,
        index: "E",
        name: "Sonya Partymaker",
        type: "PROGRAMMING",
        points: 2000,
        rating: 3300,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 713,
        index: "C",
        name: "Sonya and Problem Wihtout a Legend",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2300,
        tags: [
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 712,
        index: "D",
        name: "Memory and Scores",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2200,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 711,
        index: "C",
        name: "Coloring Trees",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 710,
        index: "E",
        name: "Generate a String",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dfs and similar",
            "dp"
        ]
    },
    {
        contestId: 708,
        index: "E",
        name: "Student's Camp",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3100,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 708,
        index: "C",
        name: "Centroids",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2300,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "graphs",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 706,
        index: "C",
        name: "Hard problem",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1600,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 706,
        index: "B",
        name: "Interesting drink",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1100,
        tags: [
            "binary search",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 704,
        index: "C",
        name: "Black Widow",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2900,
        tags: [
            "dp",
            "graphs",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 704,
        index: "B",
        name: "Ant Man",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2500,
        tags: [
            "dp",
            "graphs",
            "greedy"
        ]
    },
    {
        contestId: 703,
        index: "E",
        name: "Mishka and Divisors",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2600,
        tags: [
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 702,
        index: "A",
        name: "Maximum Increase",
        type: "PROGRAMMING",
        rating: 800,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 700,
        index: "B",
        name: "Connecting Universities",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1800,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 698,
        index: "C",
        name: "LRU",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2400,
        tags: [
            "bitmasks",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 698,
        index: "A",
        name: "Vacations",
        type: "PROGRAMMING",
        points: 500,
        rating: 1400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 696,
        index: "D",
        name: "Legen...",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "data structures",
            "dp",
            "matrices",
            "strings"
        ]
    },
    {
        contestId: 696,
        index: "C",
        name: "PLEASE",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "combinatorics",
            "dp",
            "implementation",
            "math",
            "matrices"
        ]
    },
    {
        contestId: 691,
        index: "F",
        name: "Couple Cover",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "brute force",
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 690,
        index: "D3",
        name: "The Wall (hard)",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 689,
        index: "E",
        name: "Mike and Geometry Problem",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2000,
        tags: [
            "combinatorics",
            "data structures",
            "dp",
            "geometry",
            "implementation"
        ]
    },
    {
        contestId: 687,
        index: "C",
        name: "The Values You Can Make",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 685,
        index: "B",
        name: "Kay and Snowflake",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1900,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 685,
        index: "A",
        name: "Robbers' watch",
        type: "PROGRAMMING",
        points: 500,
        rating: 1700,
        tags: [
            "brute force",
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 682,
        index: "D",
        name: "Alyona and Strings",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 682,
        index: "C",
        name: "Alyona and the Tree",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1600,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 679,
        index: "B",
        name: "Bear and Tower of Cubes",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2200,
        tags: [
            "binary search",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 678,
        index: "E",
        name: "Another Sith Tournament",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "bitmasks",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 677,
        index: "E",
        name: "Vanya and Balloons",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "binary search",
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 677,
        index: "D",
        name: "Vanya and Treasure",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "data structures",
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 676,
        index: "C",
        name: "Vasya and String",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "binary search",
            "dp",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 675,
        index: "E",
        name: "Trains and Statistic",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 671,
        index: "D",
        name: "Roads in Yusland",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2900,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 671,
        index: "A",
        name: "Recycling Bottles",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "dp",
            "geometry",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 666,
        index: "A",
        name: "Reberland Linguistics",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "dp",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 665,
        index: "F",
        name: "Four Divisors",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "data structures",
            "dp",
            "math",
            "number theory",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 665,
        index: "C",
        name: "Simple Strings",
        type: "PROGRAMMING",
        rating: 1300,
        tags: [
            "dp",
            "greedy",
            "strings"
        ]
    },
    {
        contestId: 662,
        index: "E",
        name: "To Hack or not to Hack",
        type: "PROGRAMMING",
        points: 2250,
        rating: 3100,
        tags: [
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 662,
        index: "C",
        name: "Binary Table",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2600,
        tags: [
            "bitmasks",
            "brute force",
            "divide and conquer",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 660,
        index: "C",
        name: "Hard Process",
        type: "PROGRAMMING",
        rating: 1600,
        tags: [
            "binary search",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 659,
        index: "G",
        name: "Fence Divercity",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "combinatorics",
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 653,
        index: "B",
        name: "Bear and Compressing",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1300,
        tags: [
            "brute force",
            "dfs and similar",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 651,
        index: "A",
        name: "Joysticks",
        type: "PROGRAMMING",
        points: 500,
        rating: 1100,
        tags: [
            "dp",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 650,
        index: "D",
        name: "Zip-line",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "hashing"
        ]
    },
    {
        contestId: 650,
        index: "C",
        name: "Table Compression",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2200,
        tags: [
            "dfs and similar",
            "dp",
            "dsu",
            "graphs",
            "greedy"
        ]
    },
    {
        contestId: 650,
        index: "B",
        name: "Image Preview",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "binary search",
            "brute force",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 645,
        index: "E",
        name: "Intellectual Inquiry",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "dp",
            "greedy",
            "strings"
        ]
    },
    {
        contestId: 645,
        index: "D",
        name: "Robot Rapping Results Report",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "binary search",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 643,
        index: "F",
        name: "Bears and Juice",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2900,
        tags: [
            "dp",
            "math",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 643,
        index: "E",
        name: "Bear and Destroying Subtrees",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2700,
        tags: [
            "dp",
            "math",
            "probabilities",
            "trees"
        ]
    },
    {
        contestId: 643,
        index: "C",
        name: "Levels and Regions",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 641,
        index: "D",
        name: "Little Artem and Random Variable",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2400,
        tags: [
            "dp",
            "implementation",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 637,
        index: "D",
        name: "Running with Obstacles",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1600,
        tags: [
            "*special",
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 633,
        index: "F",
        name: "The Chocolate Spree",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2600,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 633,
        index: "D",
        name: "Fibonacci-ish",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2000,
        tags: [
            "brute force",
            "dp",
            "hashing",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 633,
        index: "C",
        name: "Spy Syndrome 2",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "data structures",
            "dp",
            "hashing",
            "implementation",
            "sortings",
            "string suffix structures",
            "strings"
        ]
    },
    {
        contestId: 632,
        index: "E",
        name: "Thief in a Shop",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "divide and conquer",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 631,
        index: "E",
        name: "Product Sum",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "data structures",
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 629,
        index: "E",
        name: "Famil Door and Roads",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "combinatorics",
            "data structures",
            "dfs and similar",
            "dp",
            "probabilities",
            "trees"
        ]
    },
    {
        contestId: 629,
        index: "D",
        name: "Babaei and Birthday Cake",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 629,
        index: "C",
        name: "Famil Door and Brackets",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2000,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 628,
        index: "D",
        name: "Magic Numbers",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 628,
        index: "B",
        name: "New Skateboard",
        type: "PROGRAMMING",
        rating: 1300,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 627,
        index: "D",
        name: "Preorder Test",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "binary search",
            "dfs and similar",
            "dp",
            "graphs",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 627,
        index: "A",
        name: "XOR Equation",
        type: "PROGRAMMING",
        points: 500,
        rating: 1700,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 626,
        index: "G",
        name: "Raffles",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3100,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 626,
        index: "F",
        name: "Group Projects",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 626,
        index: "D",
        name: "Jerry's Protest",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1800,
        tags: [
            "brute force",
            "combinatorics",
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 626,
        index: "B",
        name: "Cards",
        type: "PROGRAMMING",
        points: 750,
        rating: 1300,
        tags: [
            "constructive algorithms",
            "dp",
            "math"
        ]
    },
    {
        contestId: 623,
        index: "E",
        name: "Transforming Sequence",
        type: "PROGRAMMING",
        points: 2250,
        rating: 3300,
        tags: [
            "combinatorics",
            "dp",
            "fft",
            "math"
        ]
    },
    {
        contestId: 623,
        index: "C",
        name: "Electric Charges",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2900,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 623,
        index: "B",
        name: "Array GCD",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2300,
        tags: [
            "dp",
            "greedy",
            "number theory"
        ]
    },
    {
        contestId: 621,
        index: "E",
        name: "Wet Shark and Blocks",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2000,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 618,
        index: "G",
        name: "Combining Slimes",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3300,
        tags: [
            "dp",
            "math",
            "matrices",
            "probabilities"
        ]
    },
    {
        contestId: 618,
        index: "D",
        name: "Hamiltonian Spanning Tree",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2200,
        tags: [
            "dfs and similar",
            "dp",
            "graph matchings",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 615,
        index: "C",
        name: "Running Track",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2000,
        tags: [
            "dp",
            "greedy",
            "strings",
            "trees"
        ]
    },
    {
        contestId: 615,
        index: "B",
        name: "Longtail Hedgehog",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1600,
        tags: [
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 613,
        index: "E",
        name: "Puzzle Lover",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3200,
        tags: [
            "dp",
            "hashing",
            "strings"
        ]
    },
    {
        contestId: 613,
        index: "D",
        name: "Kingdom and its Cities",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2800,
        tags: [
            "dfs and similar",
            "divide and conquer",
            "dp",
            "graphs",
            "sortings",
            "trees"
        ]
    },
    {
        contestId: 613,
        index: "B",
        name: "Skills",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1900,
        tags: [
            "binary search",
            "brute force",
            "dp",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 612,
        index: "F",
        name: "Simba on the Circle",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 611,
        index: "D",
        name: "New Year and Ancient Prophecy",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2000,
        tags: [
            "dp",
            "hashing",
            "strings"
        ]
    },
    {
        contestId: 611,
        index: "C",
        name: "New Year and Domino",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1500,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 607,
        index: "B",
        name: "Zuma",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 607,
        index: "A",
        name: "Chain Reaction",
        type: "PROGRAMMING",
        points: 500,
        rating: 1600,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 603,
        index: "A",
        name: "Alternative Thinking",
        type: "PROGRAMMING",
        points: 500,
        rating: 1600,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 602,
        index: "B",
        name: "Approximating a Constant Range",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "dp",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 601,
        index: "E",
        name: "A Museum Robbery",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2800,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 601,
        index: "C",
        name: "Kleofáš and the n-thlon",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2300,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 599,
        index: "E",
        name: "Sandy and Nuts",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2600,
        tags: [
            "bitmasks",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 598,
        index: "E",
        name: "Chocolate Bar",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 597,
        index: "C",
        name: "Subsequences",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 597,
        index: "B",
        name: "Restaurant",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1600,
        tags: [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 596,
        index: "E",
        name: "Wilbur and Strings",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "strings"
        ]
    },
    {
        contestId: 596,
        index: "D",
        name: "Wilbur and Trees",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2300,
        tags: [
            "dp",
            "math",
            "probabilities",
            "sortings"
        ]
    },
    {
        contestId: 593,
        index: "E",
        name: "Strange Calculation and Cats",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2400,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 592,
        index: "D",
        name: "Super M",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 590,
        index: "D",
        name: "Top Secret Task",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2300,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 587,
        index: "B",
        name: "Duff in Beach",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 585,
        index: "F",
        name: "Digits of Number Pi",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3200,
        tags: [
            "dp",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 582,
        index: "E",
        name: "Boolean Function",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "bitmasks",
            "dp",
            "expression parsing"
        ]
    },
    {
        contestId: 582,
        index: "D",
        name: "Number of Binominal Coefficients",
        type: "PROGRAMMING",
        points: 2250,
        rating: 3300,
        tags: [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 582,
        index: "B",
        name: "Once Again...",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1900,
        tags: [
            "constructive algorithms",
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 581,
        index: "F",
        name: "Zublicanes and Mumocrates",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2400,
        tags: [
            "dp",
            "trees",
            "two pointers"
        ]
    },
    {
        contestId: 581,
        index: "E",
        name: "Kojiro and Furrari",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2800,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 580,
        index: "D",
        name: "Kefa and Dishes",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 580,
        index: "A",
        name: "Kefa and First Steps",
        type: "PROGRAMMING",
        points: 750,
        rating: 900,
        tags: [
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 578,
        index: "D",
        name: "LCS Again",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 577,
        index: "B",
        name: "Modulo Sum",
        type: "PROGRAMMING",
        points: 1250,
        rating: 1900,
        tags: [
            "combinatorics",
            "data structures",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 576,
        index: "D",
        name: "Flights for Regular Customers",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2700,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 575,
        index: "H",
        name: "Bots",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 575,
        index: "F",
        name: "Bulbo",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 573,
        index: "D",
        name: "Bear and Cavalry",
        type: "PROGRAMMING",
        points: 2000,
        rating: 3000,
        tags: [
            "data structures",
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 573,
        index: "B",
        name: "Bear and Blocks",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1600,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "math"
        ]
    },
    {
        contestId: 571,
        index: "B",
        name: "Minimization",
        type: "PROGRAMMING",
        points: 1250,
        rating: 2000,
        tags: [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 570,
        index: "E",
        name: "Pig and Palindromes",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 568,
        index: "E",
        name: "Longest Increasing Subsequence",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 568,
        index: "B",
        name: "Symmetric and Transitive",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 567,
        index: "F",
        name: "Mausoleum",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 567,
        index: "C",
        name: "Geometric Progression",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "binary search",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 566,
        index: "F",
        name: "Clique in the Divisibility Graph",
        type: "PROGRAMMING",
        points: 500,
        rating: 1500,
        tags: [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 559,
        index: "E",
        name: "Gerald and Path",
        type: "PROGRAMMING",
        points: 2250,
        rating: 3000,
        tags: [
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 559,
        index: "C",
        name: "Gerald and Giant Chess",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2200,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 557,
        index: "E",
        name: "Ann and Half-Palindrome",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "data structures",
            "dp",
            "graphs",
            "string suffix structures",
            "strings",
            "trees"
        ]
    },
    {
        contestId: 557,
        index: "C",
        name: "Arthur and Table",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        contestId: 553,
        index: "E",
        name: "Kyoya and Train",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3200,
        tags: [
            "dp",
            "fft",
            "graphs",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 553,
        index: "A",
        name: "Kyoya and Colored Balls",
        type: "PROGRAMMING",
        points: 250,
        rating: 1500,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 552,
        index: "E",
        name: "Vanya and Brackets",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "brute force",
            "dp",
            "expression parsing",
            "greedy",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 552,
        index: "C",
        name: "Vanya and Scales",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "math",
            "meet-in-the-middle",
            "number theory"
        ]
    },
    {
        contestId: 550,
        index: "C",
        name: "Divisibility by Eight",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1500,
        tags: [
            "brute force",
            "dp",
            "math"
        ]
    },
    {
        contestId: 550,
        index: "A",
        name: "Two Substrings",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1500,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "strings"
        ]
    },
    {
        contestId: 548,
        index: "B",
        name: "Mike and Fun",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "brute force",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 547,
        index: "C",
        name: "Mike and Foam",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2300,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 547,
        index: "B",
        name: "Mike and Feet",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "dsu"
        ]
    },
    {
        contestId: 546,
        index: "D",
        name: "Soldier and Number Game",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "constructive algorithms",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 545,
        index: "C",
        name: "Woodcutters",
        type: "PROGRAMMING",
        points: 1750,
        rating: 1500,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 543,
        index: "D",
        name: "Road Improvement",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2300,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 543,
        index: "C",
        name: "Remembering Strings",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2500,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 543,
        index: "A",
        name: "Writing Code",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 542,
        index: "F",
        name: "Quest",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2100,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 542,
        index: "D",
        name: "Superhero's Job",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2600,
        tags: [
            "dfs and similar",
            "dp",
            "hashing",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 540,
        index: "D",
        name: "Bad Luck Island",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 538,
        index: "E",
        name: "Demiurges Play Again",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "dfs and similar",
            "dp",
            "math",
            "trees"
        ]
    },
    {
        contestId: 538,
        index: "B",
        name: "Quasi Binary",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 536,
        index: "D",
        name: "Tavas in Kansas",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2900,
        tags: [
            "dp",
            "games"
        ]
    },
    {
        contestId: 534,
        index: "F",
        name: "Simplified Nonogram",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2400,
        tags: [
            "bitmasks",
            "dp",
            "hashing",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 534,
        index: "B",
        name: "Covered Path",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 533,
        index: "E",
        name: "Correcting Mistakes",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy",
            "hashing",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 533,
        index: "D",
        name: "Landmarks",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3000,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 533,
        index: "B",
        name: "Work Group",
        type: "PROGRAMMING",
        points: 750,
        rating: 2000,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "strings",
            "trees"
        ]
    },
    {
        contestId: 527,
        index: "D",
        name: "Clique Problem",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 526,
        index: "E",
        name: "Transmitting Levels",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2400,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 525,
        index: "E",
        name: "Anya and Cubes",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2100,
        tags: [
            "binary search",
            "bitmasks",
            "brute force",
            "dp",
            "math",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 524,
        index: "B",
        name: "Фото на память - 2 (round version)",
        type: "PROGRAMMING",
        points: 500,
        rating: 1700,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 522,
        index: "B",
        name: "Photo to Remember",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1100,
        tags: [
            "*special",
            "data structures",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 522,
        index: "A",
        name: "Reposts",
        type: "PROGRAMMING",
        points: 500,
        rating: 1200,
        tags: [
            "*special",
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 520,
        index: "E",
        name: "Pluses everywhere",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 519,
        index: "E",
        name: "A and B and Lecture Rooms",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "binary search",
            "data structures",
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 519,
        index: "D",
        name: "A and B and Interesting Substrings",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "data structures",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 518,
        index: "F",
        name: "Pasha and Pipe",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "binary search",
            "brute force",
            "combinatorics",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 518,
        index: "D",
        name: "Ilya and Escalator",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1700,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 516,
        index: "D",
        name: "Drazil and Morning Exercise",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2800,
        tags: [
            "dfs and similar",
            "dp",
            "dsu",
            "trees",
            "two pointers"
        ]
    },
    {
        contestId: 514,
        index: "E",
        name: "Darth Vader and Tree",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 513,
        index: "G3",
        name: "Inversions problem",
        type: "PROGRAMMING",
        points: 16,
        rating: 3100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 513,
        index: "G2",
        name: "Inversions problem",
        type: "PROGRAMMING",
        points: 5,
        rating: 2400,
        tags: [
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 513,
        index: "G1",
        name: "Inversions problem",
        type: "PROGRAMMING",
        points: 3,
        rating: 1800,
        tags: [
            "brute force",
            "dfs and similar",
            "dp",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 513,
        index: "E2",
        name: "Subarray Cuts",
        type: "PROGRAMMING",
        points: 12,
        rating: 2700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 513,
        index: "E1",
        name: "Subarray Cuts",
        type: "PROGRAMMING",
        points: 9,
        rating: 2600,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 512,
        index: "D",
        name: "Fox And Travelling",
        type: "PROGRAMMING",
        points: 2250,
        rating: 2900,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 510,
        index: "D",
        name: "Fox And Jumping",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "bitmasks",
            "brute force",
            "dp",
            "math"
        ]
    },
    {
        contestId: 509,
        index: "F",
        name: "Progress Monitoring",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 509,
        index: "C",
        name: "Sums of Digits",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 508,
        index: "E",
        name: "Arthur and Brackets",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 507,
        index: "E",
        name: "Breaking Good",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 507,
        index: "D",
        name: "The Maths Lecture",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 506,
        index: "E",
        name: "Mr. Kitayuta's Gift",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "combinatorics",
            "dp",
            "matrices",
            "strings"
        ]
    },
    {
        contestId: 505,
        index: "C",
        name: "Mr. Kitayuta, the Treasure Hunter",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "dfs and similar",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 505,
        index: "B",
        name: "Mr. Kitayuta's Colorful Graph",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "dfs and similar",
            "dp",
            "dsu",
            "graphs"
        ]
    },
    {
        contestId: 500,
        index: "F",
        name: "New Year Shopping",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2700,
        tags: [
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 500,
        index: "E",
        name: "New Year Domino",
        type: "PROGRAMMING",
        points: 2750,
        rating: 2300,
        tags: [
            "data structures",
            "dp",
            "dsu"
        ]
    },
    {
        contestId: 498,
        index: "E",
        name: "Stairs and Lines",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 498,
        index: "D",
        name: "Traffic Jams in the Land",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "data structures",
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 498,
        index: "B",
        name: "Name That Tune",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "dp",
            "probabilities",
            "two pointers"
        ]
    },
    {
        contestId: 497,
        index: "E",
        name: "Subsequences Return",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2900,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 494,
        index: "D",
        name: "Birthday",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2700,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 494,
        index: "C",
        name: "Helping People",
        type: "PROGRAMMING",
        points: 1750,
        rating: 2600,
        tags: [
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 494,
        index: "B",
        name: "Obsessive String",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2000,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 490,
        index: "F",
        name: "Treeland Tour",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 489,
        index: "F",
        name: "Special Matrices",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 489,
        index: "E",
        name: "Hiking",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 489,
        index: "C",
        name: "Given Length and Sum of Digits...",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1400,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 489,
        index: "B",
        name: "BerSU Ball",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1200,
        tags: [
            "dfs and similar",
            "dp",
            "graph matchings",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 487,
        index: "B",
        name: "Strip",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 486,
        index: "E",
        name: "LIS of Sequence",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "hashing",
            "math"
        ]
    },
    {
        contestId: 486,
        index: "D",
        name: "Valid Sets",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "math",
            "trees"
        ]
    },
    {
        contestId: 484,
        index: "D",
        name: "Kindergarten",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 482,
        index: "D",
        name: "Random Function and Tree",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2700,
        tags: [
            "combinatorics",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 482,
        index: "C",
        name: "Game with Strings",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2600,
        tags: [
            "bitmasks",
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 480,
        index: "D",
        name: "Parcels",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 479,
        index: "E",
        name: "Riding in a Lift",
        type: "PROGRAMMING",
        points: 2500,
        rating: 1900,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 478,
        index: "D",
        name: "Red-Green Towers",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 477,
        index: "D",
        name: "Dreamoon and Binary",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2700,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 476,
        index: "E",
        name: "Dreamoon and Strings",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 476,
        index: "B",
        name: "Dreamoon and WiFi",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1300,
        tags: [
            "bitmasks",
            "brute force",
            "combinatorics",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 474,
        index: "E",
        name: "Pillars",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2000,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "sortings",
            "trees"
        ]
    },
    {
        contestId: 474,
        index: "D",
        name: "Flowers",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 468,
        index: "E",
        name: "Permanent",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3100,
        tags: [
            "dp",
            "graph matchings",
            "math",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 467,
        index: "E",
        name: "Alex and Complicated Task",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 467,
        index: "D",
        name: "Fedor and Essay",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "hashing",
            "strings"
        ]
    },
    {
        contestId: 467,
        index: "C",
        name: "George and Job",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 466,
        index: "D",
        name: "Increase Sequence",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 466,
        index: "C",
        name: "Number of Ways",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "binary search",
            "brute force",
            "data structures",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 464,
        index: "D",
        name: "World of Darkraft - 2",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2700,
        tags: [
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 464,
        index: "C",
        name: "Substitutes in Number",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 463,
        index: "D",
        name: "Gargari and Permutations",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "implementation"
        ]
    },
    {
        contestId: 461,
        index: "B",
        name: "Appleman and Tree",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2000,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 459,
        index: "E",
        name: "Pashmak and Graph",
        type: "PROGRAMMING",
        points: 3000,
        rating: 1900,
        tags: [
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 457,
        index: "F",
        name: "An easy problem about trees",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3200,
        tags: [
            "dp",
            "games",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 455,
        index: "C",
        name: "Civilization",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "dsu",
            "ternary search",
            "trees"
        ]
    },
    {
        contestId: 455,
        index: "B",
        name: "A Lot of Games",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "dfs and similar",
            "dp",
            "games",
            "implementation",
            "strings",
            "trees"
        ]
    },
    {
        contestId: 455,
        index: "A",
        name: "Boredom",
        type: "PROGRAMMING",
        points: 500,
        rating: 1500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 453,
        index: "D",
        name: "Little Pony and Elements of Harmony",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 453,
        index: "B",
        name: "Little Pony and Harmony Chest",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2000,
        tags: [
            "bitmasks",
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 449,
        index: "E",
        name: "Jzzhu and Squares",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2900,
        tags: [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 449,
        index: "D",
        name: "Jzzhu and Numbers",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 448,
        index: "C",
        name: "Painting Fence",
        type: "PROGRAMMING",
        points: 2500,
        rating: 1900,
        tags: [
            "divide and conquer",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 446,
        index: "A",
        name: "DZY Loves Sequences",
        type: "PROGRAMMING",
        points: 500,
        rating: 1600,
        tags: [
            "dp",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 441,
        index: "E",
        name: "Valera and Number",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "bitmasks",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 440,
        index: "D",
        name: "Berland Federalization",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 439,
        index: "E",
        name: "Devu and Birthday Celebration",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 437,
        index: "E",
        name: "The Child and Polygon",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 436,
        index: "F",
        name: "Banners",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3000,
        tags: [
            "brute force",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 436,
        index: "D",
        name: "Pudding Monsters",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 435,
        index: "D",
        name: "Special Grid",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 433,
        index: "E",
        name: "Tachibana Kanade's Tofu",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 433,
        index: "B",
        name: "Kuriyama Mirai's Stones",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1200,
        tags: [
            "dp",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 432,
        index: "D",
        name: "Prefixes and Suffixes",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "dp",
            "string suffix structures",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 431,
        index: "D",
        name: "Random Task",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "binary search",
            "bitmasks",
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 431,
        index: "C",
        name: "k-Tree",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1600,
        tags: [
            "dp",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 429,
        index: "C",
        name: "Guess the Tree",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2300,
        tags: [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 429,
        index: "B",
        name: "Working out",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1600,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 427,
        index: "D",
        name: "Match & Catch",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "dp",
            "string suffix structures",
            "strings"
        ]
    },
    {
        contestId: 425,
        index: "E",
        name: "Sereja and Sets",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 425,
        index: "C",
        name: "Sereja and Two Sequences",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2300,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 424,
        index: "E",
        name: "Colored Jenga",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2500,
        tags: [
            "dfs and similar",
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 424,
        index: "D",
        name: "Biathlon Track",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "binary search",
            "brute force",
            "constructive algorithms",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 417,
        index: "D",
        name: "Cunning Gena",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "bitmasks",
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        contestId: 417,
        index: "A",
        name: "Elimination",
        type: "PROGRAMMING",
        points: 500,
        rating: 1500,
        tags: [
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 416,
        index: "E",
        name: "President's Path",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 416,
        index: "C",
        name: "Booking System",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1600,
        tags: [
            "binary search",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 416,
        index: "B",
        name: "Art Union",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1300,
        tags: [
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 414,
        index: "B",
        name: "Mashmokh and ACM",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "combinatorics",
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 413,
        index: "D",
        name: "2048",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 407,
        index: "D",
        name: "Largest Submatrix 3",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2700,
        tags: [
            "dp",
            "hashing"
        ]
    },
    {
        contestId: 407,
        index: "B",
        name: "Long Path",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1600,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 404,
        index: "D",
        name: "Minesweeper 1D",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 403,
        index: "D",
        name: "Beautiful Pairs of Numbers",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2300,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 402,
        index: "D",
        name: "Upgrading Array",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "dp",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 401,
        index: "D",
        name: "Roman and Numbers",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "bitmasks",
            "brute force",
            "combinatorics",
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 398,
        index: "B",
        name: "Painting The Wall",
        type: "PROGRAMMING",
        points: 1000,
        tags: [
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 392,
        index: "B",
        name: "Tower of Hanoi",
        type: "PROGRAMMING",
        points: 1000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 391,
        index: "F1",
        name: "Stock Trading",
        type: "PROGRAMMING",
        points: 8,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 386,
        index: "D",
        name: "Game with Points",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "dp",
            "graphs",
            "implementation",
            "shortest paths"
        ]
    },
    {
        contestId: 386,
        index: "C",
        name: "Diverse Substrings",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "dp",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 385,
        index: "D",
        name: "Bear and Floodlight",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "bitmasks",
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 385,
        index: "C",
        name: "Bear and Prime Numbers",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "binary search",
            "brute force",
            "data structures",
            "dp",
            "implementation",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 383,
        index: "E",
        name: "Vowels",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "combinatorics",
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 383,
        index: "D",
        name: "Antimatter",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2300,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 382,
        index: "E",
        name: "Ksenia and Combinatorics",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2600,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 379,
        index: "G",
        name: "New Year Cactus",
        type: "PROGRAMMING",
        points: 3500,
        rating: 3100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 379,
        index: "D",
        name: "New Year Letter",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "bitmasks",
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 377,
        index: "E",
        name: "Cookie Clicker",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2800,
        tags: [
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 377,
        index: "C",
        name: "Captains Mode",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2200,
        tags: [
            "bitmasks",
            "dp",
            "games"
        ]
    },
    {
        contestId: 375,
        index: "E",
        name: "Red and Black Tree",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 375,
        index: "B",
        name: "Maximum Submatrix 2",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1600,
        tags: [
            "data structures",
            "dp",
            "implementation",
            "sortings"
        ]
    },
    {
        contestId: 374,
        index: "D",
        name: "Inna and Sequence ",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 374,
        index: "C",
        name: "Inna and Dima",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "implementation"
        ]
    },
    {
        contestId: 372,
        index: "C",
        name: "Watching Fireworks is Fun",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "data structures",
            "dp",
            "math"
        ]
    },
    {
        contestId: 372,
        index: "B",
        name: "Counting Rectangles is Fun",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "brute force",
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 370,
        index: "E",
        name: "Summer Reading",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2500,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 369,
        index: "D",
        name: "Valera and Fools",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 368,
        index: "B",
        name: "Sereja and Suffixes",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1100,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 367,
        index: "E",
        name: "Sereja and Intervals",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2700,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 366,
        index: "C",
        name: "Dima and Salad",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 364,
        index: "B",
        name: "Free Market",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2200,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 363,
        index: "B",
        name: "Fence",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1100,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 362,
        index: "C",
        name: "Insertion Sort",
        type: "PROGRAMMING",
        points: 2500,
        rating: 1900,
        tags: [
            "data structures",
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 360,
        index: "C",
        name: "Levko and Strings",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2500,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 360,
        index: "B",
        name: "Levko and Array",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2000,
        tags: [
            "binary search",
            "dp"
        ]
    },
    {
        contestId: 359,
        index: "B",
        name: "Permutation",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "constructive algorithms",
            "dp",
            "math"
        ]
    },
    {
        contestId: 358,
        index: "D",
        name: "Dima and Hares",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 356,
        index: "E",
        name: "Xenia and String Problem",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "dp",
            "hashing",
            "implementation",
            "string suffix structures",
            "strings"
        ]
    },
    {
        contestId: 356,
        index: "D",
        name: "Bags and Coins",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2700,
        tags: [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 354,
        index: "E",
        name: "Lucky Number Representation",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp"
        ]
    },
    {
        contestId: 354,
        index: "D",
        name: "Transferring Pyramid",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 354,
        index: "C",
        name: "Vasya and Beautiful Arrays",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "brute force",
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 354,
        index: "B",
        name: "Game with Strings",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2400,
        tags: [
            "bitmasks",
            "dp",
            "games"
        ]
    },
    {
        contestId: 353,
        index: "E",
        name: "Antichain",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2200,
        tags: [
            "dp",
            "graph matchings",
            "greedy"
        ]
    },
    {
        contestId: 353,
        index: "D",
        name: "Queue",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2000,
        tags: [
            "constructive algorithms",
            "dp"
        ]
    },
    {
        contestId: 351,
        index: "C",
        name: "Jeff and Brackets",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2500,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 351,
        index: "B",
        name: "Jeff and Furik",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "combinatorics",
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 351,
        index: "A",
        name: "Jeff and Rounding",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1800,
        tags: [
            "dp",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 349,
        index: "B",
        name: "Color the Fence",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 348,
        index: "E",
        name: "Pilgrims",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2800,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 348,
        index: "D",
        name: "Turtles",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 346,
        index: "D",
        name: "Robot Control",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 346,
        index: "B",
        name: "Lucky Common Subsequence",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2000,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 342,
        index: "D",
        name: "Xenia and Dominoes",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "bitmasks",
            "dfs and similar",
            "dp"
        ]
    },
    {
        contestId: 340,
        index: "D",
        name: "Bubble Sort Graph",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1500,
        tags: [
            "binary search",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 339,
        index: "C",
        name: "Xenia and Weights",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "graphs",
            "greedy",
            "shortest paths"
        ]
    },
    {
        contestId: 337,
        index: "D",
        name: "Book of Evil",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "dfs and similar",
            "divide and conquer",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 336,
        index: "E",
        name: "Vasily the Bear and Painting Square",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 335,
        index: "F",
        name: "Buy One, Get One Free",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3000,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 335,
        index: "E",
        name: "Counting Skyscrapers",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2800,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 335,
        index: "D",
        name: "Rectangles and Square",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 335,
        index: "B",
        name: "Palindrome",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "constructive algorithms",
            "dp"
        ]
    },
    {
        contestId: 332,
        index: "E",
        name: "Binary Key",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2400,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 332,
        index: "B",
        name: "Maximum Absurdity",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1500,
        tags: [
            "data structures",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 331,
        index: "E2",
        name: "Deja Vu",
        type: "PROGRAMMING",
        points: 50,
        rating: 3100,
        tags: [
            "constructive algorithms",
            "dp"
        ]
    },
    {
        contestId: 331,
        index: "C3",
        name: "The Great Julya Calendar",
        type: "PROGRAMMING",
        points: 60,
        rating: 2500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 331,
        index: "C2",
        name: "The Great Julya Calendar",
        type: "PROGRAMMING",
        points: 20,
        rating: 2400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 331,
        index: "C1",
        name: "The Great Julya Calendar",
        type: "PROGRAMMING",
        points: 20,
        rating: 1100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 327,
        index: "E",
        name: "Axis Walking",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2300,
        tags: [
            "bitmasks",
            "combinatorics",
            "constructive algorithms",
            "dp",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 327,
        index: "A",
        name: "Flipping Game",
        type: "PROGRAMMING",
        points: 500,
        rating: 1200,
        tags: [
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 321,
        index: "E",
        name: "Ciel and Gondolas",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "data structures",
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 321,
        index: "D",
        name: "Ciel and Flipboard",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2900,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 321,
        index: "B",
        name: "Ciel and Duel",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "dp",
            "flows",
            "greedy"
        ]
    },
    {
        contestId: 319,
        index: "C",
        name: "Kalila and Dimna in the Logging Industry",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 317,
        index: "D",
        name: "Game with Powers",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2300,
        tags: [
            "dp",
            "games"
        ]
    },
    {
        contestId: 316,
        index: "D3",
        name: "PE Lesson",
        type: "PROGRAMMING",
        points: 30,
        rating: 2400,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 316,
        index: "D2",
        name: "PE Lesson",
        type: "PROGRAMMING",
        points: 40,
        rating: 2300,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 316,
        index: "D1",
        name: "PE Lesson",
        type: "PROGRAMMING",
        points: 30,
        rating: 2300,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 316,
        index: "B2",
        name: "EKG",
        type: "PROGRAMMING",
        points: 70,
        rating: 1600,
        tags: [
            "dfs and similar",
            "dp"
        ]
    },
    {
        contestId: 314,
        index: "E",
        name: "Sereja and Squares",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 314,
        index: "C",
        name: "Sereja and Subsequences",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 313,
        index: "D",
        name: "Ilya and Roads",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 313,
        index: "B",
        name: "Ilya and Queries",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1100,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 311,
        index: "B",
        name: "Cats Transport",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2400,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 309,
        index: "B",
        name: "Context Advertising",
        type: "PROGRAMMING",
        points: 500,
        rating: 2100,
        tags: [
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 303,
        index: "E",
        name: "Random Ranking",
        type: "PROGRAMMING",
        points: 3000,
        rating: 3000,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 301,
        index: "E",
        name: "Yaroslav and Arrangements",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 300,
        index: "D",
        name: "Painting Square",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2300,
        tags: [
            "dp",
            "fft"
        ]
    },
    {
        contestId: 296,
        index: "B",
        name: "Yaroslav and Two Strings",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 295,
        index: "D",
        name: "Greg and Caves",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 295,
        index: "C",
        name: "Greg and Friends",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "combinatorics",
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 295,
        index: "B",
        name: "Greg and Graph",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 294,
        index: "E",
        name: "Shaass the Great",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "dp",
            "trees"
        ]
    },
    {
        contestId: 294,
        index: "B",
        name: "Shaass and Bookshelf",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 292,
        index: "D",
        name: "Connected Components",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "dsu"
        ]
    },
    {
        contestId: 289,
        index: "B",
        name: "Polo the Penguin and Matrix",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "brute force",
            "dp",
            "implementation",
            "sortings",
            "ternary search"
        ]
    },
    {
        contestId: 288,
        index: "E",
        name: "Polo the Penguin and Lucky Numbers",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2800,
        tags: [
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 285,
        index: "E",
        name: "Positions in Permutations",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 285,
        index: "D",
        name: "Permutation Sum",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "implementation",
            "meet-in-the-middle"
        ]
    },
    {
        contestId: 283,
        index: "D",
        name: "Cows and Cool Sequences",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 283,
        index: "C",
        name: "Coin Troubles",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 283,
        index: "B",
        name: "Cow Program",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "dfs and similar",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 282,
        index: "D",
        name: "Yet Another Number Game",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "dp",
            "games"
        ]
    },
    {
        contestId: 280,
        index: "E",
        name: "Sequence Transformation",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "brute force",
            "data structures",
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 279,
        index: "E",
        name: "Beautiful Decomposition",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dp",
            "games",
            "greedy",
            "number theory"
        ]
    },
    {
        contestId: 279,
        index: "D",
        name: "The Minimum Number of Variables",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2200,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 279,
        index: "C",
        name: "Ladder",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "dp",
            "implementation",
            "two pointers"
        ]
    },
    {
        contestId: 277,
        index: "D",
        name: "Google Code Jam",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2800,
        tags: [
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 276,
        index: "D",
        name: "Little Girl and Maximum XOR",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1700,
        tags: [
            "bitmasks",
            "dp",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        contestId: 274,
        index: "B",
        name: "Zero Tree",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1800,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 273,
        index: "E",
        name: "Dima and Game",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "dp",
            "games"
        ]
    },
    {
        contestId: 273,
        index: "D",
        name: "Dima and Figure",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 269,
        index: "D",
        name: "Maximum Waterfall",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "data structures",
            "dp",
            "graphs",
            "sortings"
        ]
    },
    {
        contestId: 269,
        index: "B",
        name: "Greenhouse Effect",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 268,
        index: "D",
        name: "Wall Bars",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 264,
        index: "E",
        name: "Roadside Trees",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 264,
        index: "D",
        name: "Colorful Stones",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 264,
        index: "C",
        name: "Choosing Balls",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 264,
        index: "B",
        name: "Good Sequences",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1500,
        tags: [
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 263,
        index: "E",
        name: "Rhombus",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2500,
        tags: [
            "brute force",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 261,
        index: "E",
        name: "Maxim and Calculator",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2800,
        tags: [
            "brute force",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 261,
        index: "D",
        name: "Maxim and Increasing Subsequence",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 261,
        index: "C",
        name: "Maxim and Matrix",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "constructive algorithms",
            "dp",
            "math"
        ]
    },
    {
        contestId: 261,
        index: "B",
        name: "Maxim and Restaurant",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 258,
        index: "D",
        name: "Little Elephant and Broken Sorting",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 258,
        index: "C",
        name: "Little Elephant and LCM",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "binary search",
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 258,
        index: "B",
        name: "Little Elephant and Elections",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "brute force",
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 256,
        index: "D",
        name: "Liars and Serge",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 255,
        index: "C",
        name: "Almost Arithmetical Progression",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1500,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 254,
        index: "E",
        name: "Dormitory",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 253,
        index: "B",
        name: "Physics Practical",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "binary search",
            "dp",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 251,
        index: "E",
        name: "Tree and Table",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "dfs and similar",
            "dp",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 251,
        index: "C",
        name: "Number Transformation",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "dp",
            "greedy",
            "number theory"
        ]
    },
    {
        contestId: 249,
        index: "D",
        name: "Donkey and Stars",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2700,
        tags: [
            "data structures",
            "dp",
            "geometry",
            "math",
            "sortings"
        ]
    },
    {
        contestId: 248,
        index: "E",
        name: "Piglet's Birthday",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 246,
        index: "E",
        name: "Blood Cousins Return",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "binary search",
            "data structures",
            "dfs and similar",
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 245,
        index: "H",
        name: "Queries for Number of Palindromes",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp",
            "hashing",
            "strings"
        ]
    },
    {
        contestId: 243,
        index: "D",
        name: "Cubes",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2700,
        tags: [
            "data structures",
            "dp",
            "geometry",
            "two pointers"
        ]
    },
    {
        contestId: 238,
        index: "E",
        name: "Meeting Her",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 238,
        index: "C",
        name: "World Eater Brothers",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 235,
        index: "E",
        name: "Number Challenge",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "combinatorics",
            "dp",
            "implementation",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 235,
        index: "B",
        name: "Let's Play Osu!",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2000,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 234,
        index: "F",
        name: "Fence",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 234,
        index: "C",
        name: "Weather",
        type: "PROGRAMMING",
        rating: 1300,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 232,
        index: "E",
        name: "Quick Tortoise",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "bitmasks",
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 232,
        index: "C",
        name: "Doe Graphs",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2600,
        tags: [
            "constructive algorithms",
            "divide and conquer",
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 232,
        index: "B",
        name: "Table",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "bitmasks",
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 231,
        index: "E",
        name: "Cactus",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2100,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 229,
        index: "E",
        name: "Gifts",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2600,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 229,
        index: "D",
        name: "Towers",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2100,
        tags: [
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        contestId: 228,
        index: "C",
        name: "Fractal Detector",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "dp",
            "hashing"
        ]
    },
    {
        contestId: 225,
        index: "C",
        name: "Barcode",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 223,
        index: "B",
        name: "Two Strings",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "data structures",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 222,
        index: "E",
        name: "Decoding Genome",
        type: "PROGRAMMING",
        points: 2500,
        rating: 1900,
        tags: [
            "dp",
            "matrices"
        ]
    },
    {
        contestId: 219,
        index: "D",
        name: "Choosing Capital for Treeland",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1700,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 219,
        index: "C",
        name: "Color Stripe",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1600,
        tags: [
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 217,
        index: "C",
        name: "Formurosa",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "divide and conquer",
            "dp",
            "expression parsing"
        ]
    },
    {
        contestId: 215,
        index: "E",
        name: "Periodical Numbers",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2100,
        tags: [
            "combinatorics",
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 213,
        index: "C",
        name: "Relay Race",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 213,
        index: "B",
        name: "Numbers",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 212,
        index: "E",
        name: "IT Restaurants",
        type: "PROGRAMMING",
        points: 500,
        rating: 1500,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 212,
        index: "C",
        name: "Cowboys",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 209,
        index: "A",
        name: "Multicolored Marbles",
        type: "PROGRAMMING",
        points: 500,
        rating: 1600,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 208,
        index: "C",
        name: "Police Station",
        type: "PROGRAMMING",
        points: 2500,
        rating: 1900,
        tags: [
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        contestId: 208,
        index: "B",
        name: "Solitaire",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dfs and similar",
            "dp"
        ]
    },
    {
        contestId: 204,
        index: "D",
        name: "Little Elephant and Retro Strings",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 204,
        index: "A",
        name: "Little Elephant and Interval",
        type: "PROGRAMMING",
        points: 500,
        rating: 1500,
        tags: [
            "binary search",
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 201,
        index: "D",
        name: "Brand New Problem",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "bitmasks",
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 201,
        index: "C",
        name: "Fragile Bridges",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 201,
        index: "A",
        name: "Clear Symmetry",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "constructive algorithms",
            "dp",
            "math"
        ]
    },
    {
        contestId: 191,
        index: "A",
        name: "Dynasty Puzzles",
        type: "PROGRAMMING",
        points: 500,
        rating: 1500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 189,
        index: "A",
        name: "Cut Ribbon",
        type: "PROGRAMMING",
        points: 500,
        rating: 1300,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 187,
        index: "B",
        name: "AlgoRace",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1800,
        tags: [
            "dp",
            "shortest paths"
        ]
    },
    {
        contestId: 185,
        index: "C",
        name: "Clever Fat Rat",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 183,
        index: "D",
        name: "T-shirt",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2700,
        tags: [
            "dp",
            "greedy",
            "probabilities"
        ]
    },
    {
        contestId: 182,
        index: "E",
        name: "Wooden Fence",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 180,
        index: "E",
        name: "Cubes",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "binary search",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 180,
        index: "C",
        name: "Letter",
        type: "PROGRAMMING",
        rating: 1400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 178,
        index: "F2",
        name: "Representative Sampling",
        type: "PROGRAMMING",
        points: 30,
        rating: 2200,
        tags: [
            "dp",
            "sortings",
            "strings"
        ]
    },
    {
        contestId: 176,
        index: "D",
        name: "Hyper String",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 176,
        index: "B",
        name: "Word Cut",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 175,
        index: "E",
        name: "Power Defence",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2600,
        tags: [
            "brute force",
            "dp",
            "geometry",
            "greedy"
        ]
    },
    {
        contestId: 175,
        index: "D",
        name: "Plane of Tanks: Duel",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "brute force",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 174,
        index: "B",
        name: "File List",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1400,
        tags: [
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 173,
        index: "C",
        name: "Spiral Maximum",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 167,
        index: "B",
        name: "Wizards and Huge Prize",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1800,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 166,
        index: "E",
        name: "Tetrahedron",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1500,
        tags: [
            "dp",
            "math",
            "matrices"
        ]
    },
    {
        contestId: 166,
        index: "D",
        name: "Shoe Store",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2500,
        tags: [
            "dp",
            "graph matchings",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        contestId: 165,
        index: "E",
        name: "Compatible Numbers",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "bitmasks",
            "brute force",
            "dfs and similar",
            "dp"
        ]
    },
    {
        contestId: 165,
        index: "C",
        name: "Another Problem on Strings",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1600,
        tags: [
            "binary search",
            "brute force",
            "dp",
            "math",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 163,
        index: "E",
        name: "e-Government",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2800,
        tags: [
            "data structures",
            "dfs and similar",
            "dp",
            "strings",
            "trees"
        ]
    },
    {
        contestId: 163,
        index: "A",
        name: "Substring and Subsequence",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 161,
        index: "E",
        name: "Polycarpus the Safecracker",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 161,
        index: "D",
        name: "Distance in Tree",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "dfs and similar",
            "dp",
            "trees"
        ]
    },
    {
        contestId: 159,
        index: "D",
        name: "Palindrome pairs",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1500,
        tags: [
            "*special",
            "brute force",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 158,
        index: "E",
        name: "Phone Talks",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "*special",
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 156,
        index: "E",
        name: "Mrs. Hudson's Pancakes",
        type: "PROGRAMMING",
        points: 2500,
        rating: 3000,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 156,
        index: "C",
        name: "Cipher",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 152,
        index: "E",
        name: "Garden",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "bitmasks",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 150,
        index: "D",
        name: "Mission Impassable",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2600,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 149,
        index: "D",
        name: "Coloring Brackets",
        type: "PROGRAMMING",
        points: 2500,
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 148,
        index: "E",
        name: "Porcelain",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 148,
        index: "D",
        name: "Bag of mice",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1800,
        tags: [
            "dp",
            "games",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 145,
        index: "C",
        name: "Lucky Subsequence",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 142,
        index: "C",
        name: "Help Caretaker",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2300,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 141,
        index: "E",
        name: "Clearing Up",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "constructive algorithms",
            "dp",
            "dsu",
            "graphs"
        ]
    },
    {
        contestId: 140,
        index: "E",
        name: "New Year Garland",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 138,
        index: "E",
        name: "Hellish Constraints",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2900,
        tags: [
            "brute force",
            "dp",
            "two pointers"
        ]
    },
    {
        contestId: 138,
        index: "D",
        name: "World of Darkraft",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "dp",
            "games"
        ]
    },
    {
        contestId: 137,
        index: "D",
        name: "Palindromes",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dp",
            "strings"
        ]
    },
    {
        contestId: 132,
        index: "D",
        name: "Constants in the language of Shakespeare",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 132,
        index: "C",
        name: "Logo Turtle",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 128,
        index: "C",
        name: "Games with Rectangle",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 126,
        index: "D",
        name: "Fibonacci Sums",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2300,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 126,
        index: "B",
        name: "Password",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "binary search",
            "dp",
            "hashing",
            "string suffix structures",
            "strings"
        ]
    },
    {
        contestId: 123,
        index: "E",
        name: "Maze",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "dfs and similar",
            "dp",
            "probabilities",
            "trees"
        ]
    },
    {
        contestId: 123,
        index: "C",
        name: "Brackets",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2300,
        tags: [
            "combinatorics",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 120,
        index: "F",
        name: "Spiders",
        type: "PROGRAMMING",
        rating: 1400,
        tags: [
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 119,
        index: "C",
        name: "Education Reform",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 118,
        index: "D",
        name: "Caesar's Legions",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 115,
        index: "E",
        name: "Linear Kingdom Races",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 115,
        index: "D",
        name: "Unambiguous Arithmetic Expression",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2600,
        tags: [
            "dp",
            "expression parsing"
        ]
    },
    {
        contestId: 111,
        index: "D",
        name: "Petya and Coloring",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2300,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 111,
        index: "C",
        name: "Petya and Spiders",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "bitmasks",
            "dp",
            "dsu"
        ]
    },
    {
        contestId: 109,
        index: "C",
        name: "Lucky Tree",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1900,
        tags: [
            "dp",
            "dsu",
            "trees"
        ]
    },
    {
        contestId: 107,
        index: "D",
        name: "Crime Management",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "dp",
            "graphs",
            "matrices"
        ]
    },
    {
        contestId: 107,
        index: "C",
        name: "Arrangement",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2400,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 107,
        index: "B",
        name: "Basketball Team",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1600,
        tags: [
            "combinatorics",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 106,
        index: "C",
        name: "Buns",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 101,
        index: "E",
        name: "Candies and Stones",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 101,
        index: "D",
        name: "Castle",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2300,
        tags: [
            "dp",
            "greedy",
            "probabilities",
            "sortings",
            "trees"
        ]
    },
    {
        contestId: 101,
        index: "B",
        name: "Buses",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1700,
        tags: [
            "binary search",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 98,
        index: "E",
        name: "Help Shrek and Donkey",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "dp",
            "games",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 95,
        index: "E",
        name: "Lucky Country",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "dp",
            "dsu",
            "graphs"
        ]
    },
    {
        contestId: 95,
        index: "D",
        name: "Horse Races",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 95,
        index: "B",
        name: "Lucky Numbers",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1800,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 93,
        index: "E",
        name: "Lostborn",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2600,
        tags: [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 93,
        index: "D",
        name: "Flags",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "dp",
            "math",
            "matrices"
        ]
    },
    {
        contestId: 89,
        index: "B",
        name: "Widget Library",
        type: "PROGRAMMING",
        points: 1000,
        rating: 2300,
        tags: [
            "dp",
            "expression parsing",
            "graphs",
            "implementation"
        ]
    },
    {
        contestId: 87,
        index: "D",
        name: "Beautiful Road",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2300,
        tags: [
            "dfs and similar",
            "dp",
            "dsu",
            "graphs",
            "implementation",
            "sortings",
            "trees"
        ]
    },
    {
        contestId: 87,
        index: "C",
        name: "Interesting Game",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "dp",
            "games",
            "math"
        ]
    },
    {
        contestId: 86,
        index: "C",
        name: "Genetic engineering",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "dp",
            "string suffix structures",
            "trees"
        ]
    },
    {
        contestId: 83,
        index: "E",
        name: "Two Subsequences",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2800,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 83,
        index: "D",
        name: "Numbers",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 82,
        index: "D",
        name: "Two out of Three",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 81,
        index: "E",
        name: "Pairs",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "dfs and similar",
            "dp",
            "dsu",
            "graphs",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 79,
        index: "D",
        name: "Password",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2800,
        tags: [
            "bitmasks",
            "dp",
            "shortest paths"
        ]
    },
    {
        contestId: 79,
        index: "C",
        name: "Beaver",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1800,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "hashing",
            "strings",
            "two pointers"
        ]
    },
    {
        contestId: 78,
        index: "C",
        name: "Beaver Game",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "dp",
            "games",
            "number theory"
        ]
    },
    {
        contestId: 77,
        index: "D",
        name: "Domino Carpet",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2300,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 77,
        index: "C",
        name: "Beavermuncher-0xFF",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2100,
        tags: [
            "dfs and similar",
            "dp",
            "dsu",
            "greedy",
            "trees"
        ]
    },
    {
        contestId: 76,
        index: "F",
        name: "Tourist",
        type: "PROGRAMMING",
        rating: 2300,
        tags: [
            "binary search",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 76,
        index: "D",
        name: "Plus and xor",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        contestId: 76,
        index: "C",
        name: "Mutation",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "bitmasks",
            "dp",
            "math"
        ]
    },
    {
        contestId: 75,
        index: "D",
        name: "Big Maximum Sum",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2000,
        tags: [
            "data structures",
            "dp",
            "greedy",
            "implementation",
            "math",
            "trees"
        ]
    },
    {
        contestId: 74,
        index: "B",
        name: "Train",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1500,
        tags: [
            "dp",
            "games",
            "greedy"
        ]
    },
    {
        contestId: 73,
        index: "C",
        name: "LionAge II",
        type: "PROGRAMMING",
        points: 1000,
        rating: 1800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 72,
        index: "G",
        name: "Fibonacci army",
        type: "PROGRAMMING",
        rating: 1000,
        tags: [
            "*special",
            "dp"
        ]
    },
    {
        contestId: 71,
        index: "E",
        name: "Nuclear Fusion",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2200,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 71,
        index: "C",
        name: "Round Table Knights",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1600,
        tags: [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        contestId: 70,
        index: "E",
        name: "Information Reform",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "dp",
            "implementation",
            "trees"
        ]
    },
    {
        contestId: 69,
        index: "D",
        name: "Dot",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dp",
            "games"
        ]
    },
    {
        contestId: 68,
        index: "D",
        name: "Half-decay tree",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "data structures",
            "divide and conquer",
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 67,
        index: "D",
        name: "Optical Experiment",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "binary search",
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 67,
        index: "C",
        name: "Sequence of Balls",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2600,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 67,
        index: "A",
        name: "Partial Teacher",
        type: "PROGRAMMING",
        points: 500,
        rating: 1800,
        tags: [
            "dp",
            "graphs",
            "greedy",
            "implementation"
        ]
    },
    {
        contestId: 66,
        index: "E",
        name: "Petya and Post",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2000,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 63,
        index: "E",
        name: "Sweets Game",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2000,
        tags: [
            "bitmasks",
            "dfs and similar",
            "dp",
            "games",
            "implementation"
        ]
    },
    {
        contestId: 62,
        index: "E",
        name: "World Evil",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2700,
        tags: [
            "dp",
            "flows"
        ]
    },
    {
        contestId: 58,
        index: "E",
        name: "Expression",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 57,
        index: "D",
        name: "Journey",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "dp",
            "math"
        ]
    },
    {
        contestId: 56,
        index: "D",
        name: "Changing a String",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 55,
        index: "D",
        name: "Beautiful numbers",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2500,
        tags: [
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 54,
        index: "D",
        name: "Writing a Song",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "brute force",
            "dp",
            "strings"
        ]
    },
    {
        contestId: 54,
        index: "C",
        name: "First Digit Law",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 53,
        index: "E",
        name: "Dead Ends",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2500,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 51,
        index: "F",
        name: "Caterpillar",
        type: "PROGRAMMING",
        points: 3000,
        rating: 2800,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        contestId: 50,
        index: "D",
        name: "Bombing",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2100,
        tags: [
            "binary search",
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 49,
        index: "E",
        name: "Common ancestor",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2300,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 49,
        index: "D",
        name: "Game",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1800,
        tags: [
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 48,
        index: "G",
        name: "Galaxy Union",
        type: "PROGRAMMING",
        rating: 2700,
        tags: [
            "dp",
            "trees",
            "two pointers"
        ]
    },
    {
        contestId: 48,
        index: "E",
        name: "Ivan the Fool VS Gorynych the Dragon",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "games",
            "graphs"
        ]
    },
    {
        contestId: 46,
        index: "E",
        name: "Comb",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "data structures",
            "dp"
        ]
    },
    {
        contestId: 45,
        index: "B",
        name: "School",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dp",
            "dsu"
        ]
    },
    {
        contestId: 44,
        index: "H",
        name: "Phone Number",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 44,
        index: "E",
        name: "Anfisa the Monkey",
        type: "PROGRAMMING",
        rating: 1400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 41,
        index: "D",
        name: "Pawn",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 39,
        index: "E",
        name: "What Has Dirichlet Got to Do with That?",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp",
            "games"
        ]
    },
    {
        contestId: 39,
        index: "C",
        name: "Moon Craters",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 38,
        index: "H",
        name: "The Great Marathon",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 38,
        index: "F",
        name: "Smart Boy",
        type: "PROGRAMMING",
        rating: 2100,
        tags: [
            "dp",
            "games",
            "strings"
        ]
    },
    {
        contestId: 38,
        index: "E",
        name: "Let's Go Rolling!",
        type: "PROGRAMMING",
        rating: 1800,
        tags: [
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 37,
        index: "D",
        name: "Lesson Timetable",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2300,
        tags: [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        contestId: 35,
        index: "D",
        name: "Animals",
        type: "PROGRAMMING",
        points: 2000,
        rating: 1700,
        tags: [
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 31,
        index: "E",
        name: "TV Game",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2400,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 30,
        index: "C",
        name: "Shooting Gallery",
        type: "PROGRAMMING",
        points: 1500,
        rating: 1800,
        tags: [
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 28,
        index: "D",
        name: "Don't fear, DravDe is kind",
        type: "PROGRAMMING",
        points: 2000,
        rating: 2400,
        tags: [
            "binary search",
            "data structures",
            "dp",
            "hashing"
        ]
    },
    {
        contestId: 28,
        index: "C",
        name: "Bath Queue",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2200,
        tags: [
            "combinatorics",
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 27,
        index: "E",
        name: "Number With The Given Amount Of Divisors",
        type: "PROGRAMMING",
        points: 2500,
        rating: 2000,
        tags: [
            "brute force",
            "dp",
            "number theory"
        ]
    },
    {
        contestId: 24,
        index: "D",
        name: "Broken robot",
        type: "PROGRAMMING",
        rating: 2400,
        tags: [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        contestId: 23,
        index: "E",
        name: "Tree",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 22,
        index: "B",
        name: "Bargaining Table",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 21,
        index: "C",
        name: "Stripe 2",
        type: "PROGRAMMING",
        points: 1500,
        rating: 2000,
        tags: [
            "binary search",
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 19,
        index: "B",
        name: "Checkout Assistant",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 18,
        index: "E",
        name: "Flag 2",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 18,
        index: "D",
        name: "Seller Bob",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 17,
        index: "C",
        name: "Balance",
        type: "PROGRAMMING",
        rating: 2500,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 16,
        index: "E",
        name: "Fish",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "bitmasks",
            "dp",
            "probabilities"
        ]
    },
    {
        contestId: 15,
        index: "E",
        name: "Triangles",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "combinatorics",
            "dp"
        ]
    },
    {
        contestId: 14,
        index: "E",
        name: "Camels",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 14,
        index: "D",
        name: "Two Paths",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "dfs and similar",
            "dp",
            "graphs",
            "shortest paths",
            "trees",
            "two pointers"
        ]
    },
    {
        contestId: 13,
        index: "D",
        name: "Triangles",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "dp",
            "geometry"
        ]
    },
    {
        contestId: 13,
        index: "C",
        name: "Sequence",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 11,
        index: "E",
        name: "Forward, march!",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "binary search",
            "dp",
            "greedy"
        ]
    },
    {
        contestId: 11,
        index: "D",
        name: "A Simple Task",
        type: "PROGRAMMING",
        rating: 2200,
        tags: [
            "bitmasks",
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 10,
        index: "D",
        name: "LCIS",
        type: "PROGRAMMING",
        rating: 2800,
        tags: [
            "dp"
        ]
    },
    {
        contestId: 10,
        index: "B",
        name: "Cinema Cashier",
        type: "PROGRAMMING",
        rating: 1500,
        tags: [
            "dp",
            "implementation"
        ]
    },
    {
        contestId: 9,
        index: "D",
        name: "How many trees?",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "combinatorics",
            "divide and conquer",
            "dp"
        ]
    },
    {
        contestId: 8,
        index: "E",
        name: "Beads",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "dp",
            "graphs"
        ]
    },
    {
        contestId: 8,
        index: "C",
        name: "Looking for Order",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "bitmasks",
            "dp"
        ]
    },
    {
        contestId: 7,
        index: "E",
        name: "Defining Macros",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "dp",
            "expression parsing",
            "implementation"
        ]
    },
    {
        contestId: 6,
        index: "D",
        name: "Lizards and Basements 2",
        type: "PROGRAMMING",
        rating: 2600,
        tags: [
            "brute force",
            "dp"
        ]
    },
    {
        contestId: 5,
        index: "C",
        name: "Longest Regular Bracket Sequence",
        type: "PROGRAMMING",
        rating: 1900,
        tags: [
            "constructive algorithms",
            "data structures",
            "dp",
            "greedy",
            "sortings",
            "strings"
        ]
    },
    {
        contestId: 4,
        index: "D",
        name: "Mysterious Present",
        type: "PROGRAMMING",
        rating: 1700,
        tags: [
            "dp",
            "sortings"
        ]
    },
    {
        contestId: 2,
        index: "B",
        name: "The least round way",
        type: "PROGRAMMING",
        rating: 2000,
        tags: [
            "dp",
            "math"
        ]
    }
]


const probdp = [
    {
        "contestId": 1618,
        "index": "D",
        "name": "Array and Operations",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "dp",
            "greedy",
            "math"
        ],
        "solved": true
    },
    {
        "contestId": 1614,
        "index": "C",
        "name": "Divan and bitwise operations",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "bitmasks",
            "combinatorics",
            "constructive algorithms",
            "dp",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1609,
        "index": "C",
        "name": "Complex Market Analysis",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "binary search",
            "dp",
            "implementation",
            "number theory",
            "schedules",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 1598,
        "index": "C",
        "name": "Delete Two Elements",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "data structures",
            "dp",
            "implementation",
            "math",
            "two pointers"
        ],
        "solved": true
    },
    {
        "contestId": 1566,
        "index": "C",
        "name": "MAX-MEX Cut",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1000,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 1555,
        "index": "C",
        "name": "Coin Rows",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "brute force",
            "constructive algorithms",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 1553,
        "index": "D",
        "name": "Backspace",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "dp",
            "greedy",
            "strings",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 1553,
        "index": "C",
        "name": "Penalty",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "bitmasks",
            "brute force",
            "dp",
            "greedy"
        ],
        "solved": true
    },
    {
        "contestId": 1553,
        "index": "B",
        "name": "Reverse String",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1300,
        "tags": [
            "brute force",
            "dp",
            "hashing",
            "implementation",
            "strings"
        ],
        "solved": false
    },
    {
        "contestId": 1547,
        "index": "E",
        "name": "Air Conditioners",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "data structures",
            "dp",
            "implementation",
            "shortest paths",
            "sortings",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 1538,
        "index": "F",
        "name": "Interesting Function",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "binary search",
            "dp",
            "math",
            "number theory"
        ],
        "solved": false
    },
    {
        "contestId": 1536,
        "index": "C",
        "name": "Diluc and Kaeya",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "data structures",
            "dp",
            "hashing",
            "number theory"
        ],
        "solved": false
    },
    {
        "contestId": 1535,
        "index": "C",
        "name": "Unstable String",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "binary search",
            "dp",
            "greedy",
            "implementation",
            "strings",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 1534,
        "index": "C",
        "name": "Little Alawn's Puzzle",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1300,
        "tags": [
            "combinatorics",
            "dp",
            "dsu",
            "graphs",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1526,
        "index": "C1",
        "name": "Potions (Easy Version)",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1500,
        "tags": [
            "brute force",
            "data structures",
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 1526,
        "index": "B",
        "name": "I Hate 1111",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "dp",
            "math",
            "number theory"
        ],
        "solved": false
    },
    {
        "contestId": 1516,
        "index": "B",
        "name": "AGAGA XOOORRR",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "bitmasks",
            "brute force",
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 1499,
        "index": "B",
        "name": "Binary Removals",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 1492,
        "index": "C",
        "name": "Maximum width",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 1485,
        "index": "B",
        "name": "Replace and Keep Sorted",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "dp",
            "implementation",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1478,
        "index": "B",
        "name": "Nezzar and Lucky Number",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1472,
        "index": "D",
        "name": "Even-Odd Game",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "dp",
            "games",
            "greedy",
            "sortings"
        ],
        "solved": false
    },
    {
        "contestId": 1472,
        "index": "C",
        "name": "Long Jumps",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "dp",
            "graphs"
        ],
        "solved": true
    },
    {
        "contestId": 1470,
        "index": "A",
        "name": "Strange Birthday Party",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1300,
        "tags": [
            "binary search",
            "dp",
            "greedy",
            "sortings",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 1469,
        "index": "B",
        "name": "Red and Blue",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "dp",
            "greedy"
        ],
        "solved": true
    },
    {
        "contestId": 1466,
        "index": "C",
        "name": "Canine poetry",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "dp",
            "greedy",
            "strings"
        ],
        "solved": false
    },
    {
        "contestId": 1461,
        "index": "C",
        "name": "Random Events",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "dp",
            "math",
            "probabilities"
        ],
        "solved": false
    },
    {
        "contestId": 1461,
        "index": "B",
        "name": "Find the Spruce",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "brute force",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 1459,
        "index": "B",
        "name": "Move and Turn",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "dp",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1451,
        "index": "C",
        "name": "String Equality",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1400,
        "tags": [
            "dp",
            "greedy",
            "hashing",
            "implementation",
            "strings"
        ],
        "solved": false
    },
    {
        "contestId": 1443,
        "index": "B",
        "name": "Saving the City",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "dp",
            "greedy",
            "math",
            "sortings"
        ],
        "solved": false
    },
    {
        "contestId": 1420,
        "index": "C1",
        "name": "Pokémon Army (easy version)",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "constructive algorithms",
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 1418,
        "index": "C",
        "name": "Mortal Kombat Tower",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "dp",
            "graphs",
            "greedy",
            "shortest paths"
        ],
        "solved": false
    },
    {
        "contestId": 1415,
        "index": "C",
        "name": "Bouncing Ball",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1400,
        "tags": [
            "brute force",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 1408,
        "index": "C",
        "name": "Discrete Acceleration",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "binary search",
            "dp",
            "implementation",
            "math",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 1406,
        "index": "B",
        "name": "Maximum Product",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "sortings"
        ],
        "solved": false
    },
    {
        "contestId": 1391,
        "index": "C",
        "name": "Cyclic Permutations ",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "combinatorics",
            "dp",
            "graphs",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1389,
        "index": "C",
        "name": "Good String",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 1385,
        "index": "D",
        "name": "a-Good String",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "bitmasks",
            "brute force",
            "divide and conquer",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 1382,
        "index": "B",
        "name": "Sequential Nim",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1100,
        "tags": [
            "dp",
            "games"
        ],
        "solved": false
    },
    {
        "contestId": 1380,
        "index": "C",
        "name": "Create The Teams",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "sortings"
        ],
        "solved": false
    },
    {
        "contestId": 1360,
        "index": "E",
        "name": "Polygon",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "dp",
            "graphs",
            "implementation",
            "shortest paths"
        ],
        "solved": false
    },
    {
        "contestId": 1359,
        "index": "B",
        "name": "New Theatre Square",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 1355,
        "index": "B",
        "name": "Young Explorers",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "dp",
            "greedy",
            "sortings"
        ],
        "solved": false
    },
    {
        "contestId": 1354,
        "index": "B",
        "name": "Ternary String",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "binary search",
            "dp",
            "implementation",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 1350,
        "index": "B",
        "name": "Orac and Models",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "dp",
            "math",
            "number theory"
        ],
        "solved": false
    },
    {
        "contestId": 1345,
        "index": "B",
        "name": "Card Constructions",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "binary search",
            "brute force",
            "dp",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1343,
        "index": "C",
        "name": "Alternating Subsequence",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "dp",
            "greedy",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 1320,
        "index": "A",
        "name": "Journey Planning",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1400,
        "tags": [
            "data structures",
            "dp",
            "greedy",
            "math",
            "sortings"
        ],
        "solved": false
    },
    {
        "contestId": 1315,
        "index": "B",
        "name": "Homecoming",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "binary search",
            "dp",
            "greedy",
            "strings"
        ],
        "solved": true
    },
    {
        "contestId": 1313,
        "index": "C1",
        "name": "Skyscrapers (easy version)",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "brute force",
            "data structures",
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 1307,
        "index": "C",
        "name": "Cow and Message",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "brute force",
            "dp",
            "math",
            "strings"
        ],
        "solved": false
    },
    {
        "contestId": 1304,
        "index": "C",
        "name": "Air Conditioner",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "dp",
            "greedy",
            "implementation",
            "sortings",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 1285,
        "index": "B",
        "name": "Just Eat It!",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "dp",
            "greedy",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 1284,
        "index": "B",
        "name": "New Year and Ascent Sequence",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1400,
        "tags": [
            "binary search",
            "combinatorics",
            "data structures",
            "dp",
            "implementation",
            "sortings"
        ],
        "solved": false
    },
    {
        "contestId": 1282,
        "index": "B1",
        "name": "K for the Price of One (Easy Version)",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1400,
        "tags": [
            "dp",
            "greedy",
            "sortings"
        ],
        "solved": false
    },
    {
        "contestId": 1276,
        "index": "A",
        "name": "As Simple as One and Two",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1400,
        "tags": [
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 1272,
        "index": "D",
        "name": "Remove One Element",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "brute force",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 1272,
        "index": "C",
        "name": "Yet Another Broken Keyboard",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "combinatorics",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 1253,
        "index": "C",
        "name": "Sweets Eating",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "dp",
            "greedy",
            "math",
            "sortings"
        ],
        "solved": false
    },
    {
        "contestId": 1245,
        "index": "C",
        "name": "Constanze's Machine",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1400,
        "tags": [
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 1245,
        "index": "B",
        "name": "Restricted RPS",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 1234,
        "index": "C",
        "name": "Pipes",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 1215,
        "index": "B",
        "name": "The Number of Products",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "combinatorics",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 1207,
        "index": "C",
        "name": "Gas Pipeline",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 1200,
        "index": "B",
        "name": "Block Adventure",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 1195,
        "index": "C",
        "name": "Basketball Exercise",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 1189,
        "index": "C",
        "name": "Candies!",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1400,
        "tags": [
            "data structures",
            "dp",
            "implementation",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1182,
        "index": "A",
        "name": "Filling Shapes",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1000,
        "tags": [
            "dp",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1178,
        "index": "B",
        "name": "WOW Factor",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1300,
        "tags": [
            "dp",
            "strings"
        ],
        "solved": false
    },
    {
        "contestId": 1176,
        "index": "C",
        "name": "Lose it!",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "dp",
            "greedy",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 1140,
        "index": "D",
        "name": "Minimum Triangulation",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "dp",
            "greedy",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1108,
        "index": "D",
        "name": "Diverse Garland",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 1105,
        "index": "C",
        "name": "Ayoub and Lost Array",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "combinatorics",
            "dp",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1097,
        "index": "B",
        "name": "Petr and a Combination Lock",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "bitmasks",
            "brute force",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 1084,
        "index": "C",
        "name": "The Fair Nut and String",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "combinatorics",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 1081,
        "index": "C",
        "name": "Colorful Bricks",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "combinatorics",
            "dp",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1051,
        "index": "C",
        "name": "Vasya and Multisets",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1042,
        "index": "B",
        "name": "Vitamins",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "bitmasks",
            "brute force",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 1040,
        "index": "B",
        "name": "Shashlik Cooking",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "dp",
            "greedy",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1037,
        "index": "C",
        "name": "Equalize",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "dp",
            "greedy",
            "strings"
        ],
        "solved": false
    },
    {
        "contestId": 1029,
        "index": "B",
        "name": "Creating the Contest",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "dp",
            "greedy",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 1005,
        "index": "D",
        "name": "Polycarp and Div 3",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "dp",
            "greedy",
            "number theory"
        ],
        "solved": false
    },
    {
        "contestId": 998,
        "index": "B",
        "name": "Cutting",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "dp",
            "greedy",
            "sortings"
        ],
        "solved": false
    },
    {
        "contestId": 991,
        "index": "D",
        "name": "Bishwock",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 987,
        "index": "C",
        "name": "Three displays",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1400,
        "tags": [
            "brute force",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 982,
        "index": "C",
        "name": "Cut 'em all!",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "dfs and similar",
            "dp",
            "graphs",
            "greedy",
            "trees"
        ],
        "solved": false
    },
    {
        "contestId": 961,
        "index": "B",
        "name": "Lecture Sleep",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "data structures",
            "dp",
            "implementation",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 940,
        "index": "B",
        "name": "Our Tanya is Crying Out Loud",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1400,
        "tags": [
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 928,
        "index": "B",
        "name": "Chat",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1400,
        "tags": [
            "*special",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 919,
        "index": "B",
        "name": "Perfect Number",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1100,
        "tags": [
            "binary search",
            "brute force",
            "dp",
            "implementation",
            "number theory"
        ],
        "solved": false
    },
    {
        "contestId": 891,
        "index": "A",
        "name": "Pride",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "math",
            "number theory"
        ],
        "solved": false
    },
    {
        "contestId": 877,
        "index": "B",
        "name": "Nikita and string",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "brute force",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 873,
        "index": "B",
        "name": "Balanced Substring",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 870,
        "index": "C",
        "name": "Maximum splitting",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1300,
        "tags": [
            "dp",
            "greedy",
            "math",
            "number theory"
        ],
        "solved": false
    },
    {
        "contestId": 868,
        "index": "C",
        "name": "Qualification Rounds",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "bitmasks",
            "brute force",
            "constructive algorithms",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 859,
        "index": "C",
        "name": "Pie Rules",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "dp",
            "games"
        ],
        "solved": false
    },
    {
        "contestId": 858,
        "index": "C",
        "name": "Did you mean...",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "dp",
            "greedy",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 855,
        "index": "B",
        "name": "Marvolo Gaunt's Ring",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "brute force",
            "data structures",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 839,
        "index": "C",
        "name": "Journey",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "dfs and similar",
            "dp",
            "graphs",
            "probabilities",
            "trees"
        ],
        "solved": false
    },
    {
        "contestId": 798,
        "index": "B",
        "name": "Mike and strings",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "brute force",
            "dp",
            "strings"
        ],
        "solved": false
    },
    {
        "contestId": 797,
        "index": "B",
        "name": "Odd sum",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "dp",
            "greedy",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 777,
        "index": "B",
        "name": "Game of Credit Cards",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "data structures",
            "dp",
            "greedy",
            "sortings"
        ],
        "solved": false
    },
    {
        "contestId": 761,
        "index": "C",
        "name": "Dasha and Password",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "brute force",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 753,
        "index": "A",
        "name": "Santa Claus and Candies",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1000,
        "tags": [
            "dp",
            "greedy",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 732,
        "index": "B",
        "name": "Cormen --- The Best Friend Of a Man",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1000,
        "tags": [
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 729,
        "index": "B",
        "name": "Spotlights",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 706,
        "index": "B",
        "name": "Interesting drink",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "binary search",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 698,
        "index": "A",
        "name": "Vacations",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1400,
        "tags": [
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 676,
        "index": "C",
        "name": "Vasya and String",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "binary search",
            "dp",
            "strings",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 665,
        "index": "C",
        "name": "Simple Strings",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "dp",
            "greedy",
            "strings"
        ],
        "solved": false
    },
    {
        "contestId": 653,
        "index": "B",
        "name": "Bear and Compressing",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "brute force",
            "dfs and similar",
            "dp",
            "strings"
        ],
        "solved": false
    },
    {
        "contestId": 651,
        "index": "A",
        "name": "Joysticks",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1100,
        "tags": [
            "dp",
            "greedy",
            "implementation",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 628,
        "index": "B",
        "name": "New Skateboard",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 626,
        "index": "B",
        "name": "Cards",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1300,
        "tags": [
            "constructive algorithms",
            "dp",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 611,
        "index": "C",
        "name": "New Year and Domino",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 602,
        "index": "B",
        "name": "Approximating a Constant Range",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "dp",
            "implementation",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 566,
        "index": "F",
        "name": "Clique in the Divisibility Graph",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "dp",
            "math",
            "number theory"
        ],
        "solved": false
    },
    {
        "contestId": 553,
        "index": "A",
        "name": "Kyoya and Colored Balls",
        "type": "PROGRAMMING",
        "points": 250,
        "rating": 1500,
        "tags": [
            "combinatorics",
            "dp",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 550,
        "index": "C",
        "name": "Divisibility by Eight",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "brute force",
            "dp",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 550,
        "index": "A",
        "name": "Two Substrings",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "strings"
        ],
        "solved": false
    },
    {
        "contestId": 548,
        "index": "B",
        "name": "Mike and Fun",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 545,
        "index": "C",
        "name": "Woodcutters",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1500,
        "tags": [
            "dp",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 538,
        "index": "B",
        "name": "Quasi Binary",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "dp",
            "greedy",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 534,
        "index": "B",
        "name": "Covered Path",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "dp",
            "greedy",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 522,
        "index": "B",
        "name": "Photo to Remember",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "*special",
            "data structures",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 522,
        "index": "A",
        "name": "Reposts",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1200,
        "tags": [
            "*special",
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ],
        "solved": false
    },
    {
        "contestId": 505,
        "index": "B",
        "name": "Mr. Kitayuta's Colorful Graph",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "dfs and similar",
            "dp",
            "dsu",
            "graphs"
        ],
        "solved": false
    },
    {
        "contestId": 489,
        "index": "C",
        "name": "Given Length and Sum of Digits...",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "dp",
            "greedy",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 489,
        "index": "B",
        "name": "BerSU Ball",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "dfs and similar",
            "dp",
            "graph matchings",
            "greedy",
            "sortings",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 476,
        "index": "B",
        "name": "Dreamoon and WiFi",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1300,
        "tags": [
            "bitmasks",
            "brute force",
            "combinatorics",
            "dp",
            "math",
            "probabilities"
        ],
        "solved": false
    },
    {
        "contestId": 455,
        "index": "A",
        "name": "Boredom",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 433,
        "index": "B",
        "name": "Kuriyama Mirai's Stones",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1200,
        "tags": [
            "dp",
            "implementation",
            "sortings"
        ],
        "solved": false
    },
    {
        "contestId": 417,
        "index": "A",
        "name": "Elimination",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "dp",
            "implementation",
            "math"
        ],
        "solved": false
    },
    {
        "contestId": 416,
        "index": "B",
        "name": "Art Union",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "brute force",
            "dp",
            "implementation"
        ],
        "solved": true
    },
    {
        "contestId": 414,
        "index": "B",
        "name": "Mashmokh and ACM",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "combinatorics",
            "dp",
            "number theory"
        ],
        "solved": false
    },
    {
        "contestId": 368,
        "index": "B",
        "name": "Sereja and Suffixes",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "data structures",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 363,
        "index": "B",
        "name": "Fence",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "brute force",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 359,
        "index": "B",
        "name": "Permutation",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "dp",
            "math"
        ],
        "solved": true
    },
    {
        "contestId": 340,
        "index": "D",
        "name": "Bubble Sort Graph",
        "type": "PROGRAMMING",
        "points": 2000,
        "rating": 1500,
        "tags": [
            "binary search",
            "data structures",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 332,
        "index": "B",
        "name": "Maximum Absurdity",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "data structures",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 331,
        "index": "C1",
        "name": "The Great Julya Calendar",
        "type": "PROGRAMMING",
        "points": 20,
        "rating": 1100,
        "tags": [
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 327,
        "index": "A",
        "name": "Flipping Game",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1200,
        "tags": [
            "brute force",
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 313,
        "index": "B",
        "name": "Ilya and Queries",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 289,
        "index": "B",
        "name": "Polo the Penguin and Matrix",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "brute force",
            "dp",
            "implementation",
            "sortings",
            "ternary search"
        ],
        "solved": false
    },
    {
        "contestId": 264,
        "index": "B",
        "name": "Good Sequences",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "dp",
            "number theory"
        ],
        "solved": false
    },
    {
        "contestId": 255,
        "index": "C",
        "name": "Almost Arithmetical Progression",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "brute force",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 253,
        "index": "B",
        "name": "Physics Practical",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "binary search",
            "dp",
            "sortings",
            "two pointers"
        ],
        "solved": false
    },
    {
        "contestId": 234,
        "index": "C",
        "name": "Weather",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "dp",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 212,
        "index": "E",
        "name": "IT Restaurants",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "dfs and similar",
            "dp",
            "trees"
        ],
        "solved": false
    },
    {
        "contestId": 204,
        "index": "A",
        "name": "Little Elephant and Interval",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "binary search",
            "combinatorics",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 191,
        "index": "A",
        "name": "Dynasty Puzzles",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 189,
        "index": "A",
        "name": "Cut Ribbon",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1300,
        "tags": [
            "brute force",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 180,
        "index": "C",
        "name": "Letter",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 174,
        "index": "B",
        "name": "File List",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "dp",
            "greedy",
            "implementation"
        ],
        "solved": false
    },
    {
        "contestId": 166,
        "index": "E",
        "name": "Tetrahedron",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "dp",
            "math",
            "matrices"
        ],
        "solved": false
    },
    {
        "contestId": 159,
        "index": "D",
        "name": "Palindrome pairs",
        "type": "PROGRAMMING",
        "points": 2000,
        "rating": 1500,
        "tags": [
            "*special",
            "brute force",
            "dp",
            "strings"
        ],
        "solved": false
    },
    {
        "contestId": 120,
        "index": "F",
        "name": "Spiders",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "dp",
            "greedy",
            "trees"
        ],
        "solved": false
    },
    {
        "contestId": 74,
        "index": "B",
        "name": "Train",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "dp",
            "games",
            "greedy"
        ],
        "solved": false
    },
    {
        "contestId": 72,
        "index": "G",
        "name": "Fibonacci army",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "*special",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 44,
        "index": "E",
        "name": "Anfisa the Monkey",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 22,
        "index": "B",
        "name": "Bargaining Table",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "brute force",
            "dp"
        ],
        "solved": false
    },
    {
        "contestId": 10,
        "index": "B",
        "name": "Cinema Cashier",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "dp",
            "implementation"
        ],
        "solved": false
    }
]




export default probdp1;
export { probdp };